import { openBlock, createElementBlock, mergeProps, renderSlot, normalizeStyle, normalizeClass, createCommentVNode, toDisplayString, ref, createElementVNode, onMounted, onUnmounted, watch, computed, reactive, unref, withModifiers, createBlock, resolveDynamicComponent, Fragment, createTextVNode, withDirectives, createVNode, vShow, renderList, resolveComponent, withCtx, resolveDirective, Transition, Teleport, toHandlerKey, withKeys, useCssVars, onBeforeUnmount, getCurrentInstance, createApp, TransitionGroup, onBeforeUpdate, onUpdated } from 'vue';
import { computePosition, flip, shift, offset } from '@floating-ui/dom';
import Swal from 'sweetalert2';

var script$o = {
  name: 'AriButton',
  methods: {
    emitIfNotDisabled () {
      if (!this.disabled) this.$emit('clicke');
      else this.$emit('clickWhenDisable');
    }
  },
  computed: {
    useAccentColor () {
      if (this.valid) return 'valid-green';
      else if (this.pending) return 'pending-yellow';
      else if (this.attention) return 'attention-purple';
      else if (this.error) return 'error-red';
      else if (this.trivial) return 'trivial-grey';
      else if (this.secondary) return 'ari-button-secondary';
      else return false;
    },
    manualFontSize () {
      return this.fontSize ? `font-size: ${this.fontSize}px` : null;
    },
    generatedCSSContent () {
      const css = [];
      if (this.light) css.push('ari-font-light');
      else if (this.medium) css.push('ari-font-medium');
      return css;
    },
    generatedCSSButton () {
      const css = [];
      if ((this.$attrs['data-theme'] || this.useDataTheme) && !this.useAccentColor) {
        css.push('data-theme');
      } else if (this.useAccentColor) {
        css.push('use-accent-color');
        css.push(this.useAccentColor);
      } else {
        if (this.useCustomColor) css.push('useCustomColor');
        if (this.useCustomBgColor) css.push('useCustomBgColor');
      }
      if (this.text || this.link) {
        css.push('ari-text');
        if (this.removePaddingRight) css.push('remove-padding-right');
        else if (this.removePaddingLeft) css.push('remove-padding-left');
      } else {
        if (this.content) {
          css.push('ari-button');
        } else css.push('ari-button__icon-only');
        if (this.filled) css.push('ari-button-filled');
        else css.push('ari-button-outlined');
        if (this.rounded) css.push('ari-button-rounded');
      }
      if (this.disabled) css.push('ari-button-disabled');
      if (this.underline) css.push('ari-button__underline');
      if (this.small) css.push('ari-button-small');
      else if (this.large) css.push('ari-button-large');
      else css.push('ari-button-standard');
      return css;
    }
  },
  props: {
    /**
     * AJoute text-decoration: underline
     */
    underline: Boolean,
    /**
     * Contenu du bouton.
     */
    content: [String, Number],
    /**
     * Affiche un bouton avec background-color
     */
    filled: {
      type: Boolean,
      default: false
    },
    /**
     * Affiche un bouton sous forme de texte
     */
    text: {
      type: Boolean,
      default: false
    },
    /** Affiche un bouton aux bords très arrondis */
    rounded: Boolean,
    /**
     * Affiche un bouton sous forme de texte. Deprecated
     */
    link: Boolean, // Deprecated, on utilise text maintenant
    /**
     * Affiche un bouton sans backgroud color avec border
     */
    outlined: {
      type: Boolean,
      default: true
    },
    /**
     * Force la font-weight en medium
     */
    medium: {
      type: Boolean,
      default: false
    },
    /**
     * Force la font-weight en light
     */
    light: {
      type: Boolean,
      default: false
    },
    /**
     * Force la fontSize du content
     */
    fontSize: {
      type: [Number, String]
    },
    /** Le bouton sera aux couleurs de ariane-secondary-500 */
    secondary: Boolean,
    /**
     * Force la color de outlined/ Filled en ariane-attention-valid
     */
    valid: Boolean,
    /**
     * Force la color de outlined/ Filled en ariane-attention-pending
    */
    pending: Boolean,
    /**
     * Force la color de outlined/ Filled en ariane-attention-purple
    */
    attention: Boolean,
    /**
     * Force la color de outlined/ Filled en ariane-attention-error
    */
    error: Boolean,
    /**
     * Force la color de outline/ Filled en ariane-trivial
     */
    trivial: Boolean,
    /**
     * Force la color de outlined/ Filled en var(--custom-color);. Cette variable doitêtre passé en inline style au button
    */
    useCustomColor: Boolean,
    /**
     * Force la bg- de outlined/ Filled en var(--custom-bg-color);. Cette variable doitêtre passé en inline style au button
    */
    useCustomBgColor: Boolean,
    /**
     * Icone avant le content.
    */
    preIcon: String,
    /**
     * Icone après le content.
    */
    postIcon: String,
        /**
     * Disable le button. Il emitera @clickWhenDisable et changera de style.
    */
    disabled: Boolean,
    /**
     * Force l'utilisation des couleurs du data-theme
     */
    useDataTheme: Boolean,
    /**
     * Title du button
     */
    title: String,
    /** 
     * Vire le padding right pour pouvoir ferrer le bouton a droite ( a utiliser sur text)
     */
    removePaddingRight: Boolean,
    /** 
     * Vire le padding left pour pouvoir ferrer le bouton a gauche ( a utiliser sur text)
     */
    removePaddingLeft: Boolean,
    /**
     * Size du button, padding minimum
     */
    small: Boolean,
    /**
     * Size du button, padding standard
     */
    medium: Boolean,
    /**
     * Size du button, padding large
     */
    large: Boolean
  }
};

const _hoisted_1$l = ["title", "disabled"];

function render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("button", mergeProps({
    onClick: _cache[0] || (_cache[0] = $event => ($options.emitIfNotDisabled())),
    class: $options.generatedCSSButton
  }, _ctx.$attrs, {
    type: "button",
    title: $props.title,
    class: "ari-button-base",
    disabled: $props.disabled
  }), [
    renderSlot(_ctx.$slots, "default"),
    ($props.preIcon)
      ? (openBlock(), createElementBlock("i", {
          key: 0,
          style: normalizeStyle($options.manualFontSize),
          class: normalizeClass([[$props.preIcon], "ari-button-icon"])
        }, null, 6 /* CLASS, STYLE */))
      : createCommentVNode("v-if", true),
    ($props.content)
      ? (openBlock(), createElementBlock("span", {
          key: 1,
          style: normalizeStyle($options.manualFontSize),
          class: normalizeClass([$options.generatedCSSContent])
        }, toDisplayString($props.content), 7 /* TEXT, CLASS, STYLE */))
      : createCommentVNode("v-if", true),
    ($props.postIcon)
      ? (openBlock(), createElementBlock("i", {
          key: 2,
          style: normalizeStyle($options.manualFontSize),
          class: normalizeClass([$props.postIcon])
        }, null, 6 /* CLASS, STYLE */))
      : createCommentVNode("v-if", true)
  ], 16 /* FULL_PROPS */, _hoisted_1$l))
}

script$o.render = render$f;
script$o.__file = "src/components/Ari-Button/ari-button.vue";

var script$n = {
  name: 'AriForm',
  mounted () {
    window.addEventListener('keydown', this.handleKeyUpEnter);
  },
  beforeUnmount () {
    window.removeEventListener('keydown', this.handleKeyUpEnter);
  },
  props: {
    edited: Boolean
  },
  emits: ['update:edited', 'action'],
  computed: {
    async isEdited () {
      let isEdited = false;
      this.differentValues = [];
      Object.keys(this.modelValues).forEach(key => {
        const component = this.modelValues[key]; 
        Object.keys(component).forEach(keyModel => {
          const componentModel = component[keyModel];
          // Si on doit comparer des array, on sort
          // Si c'est du tableau d'objet, ça va commencé à être chiant a gérer
          if (Array.isArray(componentModel.origin) && Array.isArray(componentModel.value)) {
            componentModel.origin = componentModel.origin.sort((a, b) => a - b);
            componentModel.value = componentModel.value.sort((a, b) => a - b);
          }

          if (!this._deepEqual(componentModel.origin, componentModel.value)) { isEdited = true; this.differentValues.push(key);}
        });
      });
      this.$emit('update:edited', isEdited);
      return isEdited;
    }
  },
  data () {
    return {
      validateComponents: [],
      isMouseInForm: false,
      modelValues: {},
      differentValues: []
    }
  },
  methods: {
    _deepEqual (x, y) {
      const xAndYAreObjects = x && y && typeof x === 'object' && typeof y === 'object';
      if (!xAndYAreObjects) return x === y;
      const sameLength = Object.keys(x).length === Object.keys(y).length;
      if (!sameLength) return false;
      return Object.keys(x).every(key => this._deepEqual(x[key], y[key]));
    },
    handleKeyUpEnter (e) {
      if (this.isMouseInForm && e.keyCode === 13) this.$emit('action');
    },
    bind (componentObj) {
      this.validateComponents.push(componentObj);
    },
    unbind (uidToDelete) {
      this.validateComponents.push(uidToDelete);
    },
    resetOrigins () {
      for (const component of this.validateComponents) {
        component.setFormDatas();
      }
    },
    validateForm () {
      let valid = true;
      for (const component of this.validateComponents) {
        const result = component.checkFormatter();
        if (!result) valid = false;
      }
      return valid;
    }
  }
};

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("form", {
    onMouseover: _cache[0] || (_cache[0] = $event => ($data.isMouseInForm = true)),
    onMouseleave: _cache[1] || (_cache[1] = $event => ($data.isMouseInForm = false)),
    action: "javascript:void(-1)"
  }, [
    renderSlot(_ctx.$slots, "default", {
      bind: $options.bind,
      unbind: $options.unbind,
      modelValues: $data.modelValues,
      isEdited: $options.isEdited
    })
  ], 32 /* NEED_HYDRATION */))
}

script$n.render = render$e;
script$n.__file = "src/components/Ari-Form/ari-form.vue";

const _hoisted_1$k = ["id"];
const _hoisted_2$j = /*#__PURE__*/createElementVNode("i", { class: "fa-regular fa-triangle-exclamation" }, null, -1 /* HOISTED */);
const _hoisted_3$i = { class: "ari-absolute-text-error" };
  
var script$m = {
  __name: 'AbsoluteError',
  props: {
    uid: {
      required: true,
      type: String
    },
    parentContainerId: {
      required: true,
      type: String
    },
    text: {
      type: [String],
    },
    top: {
      type: [String, Number],
      default: 35
    }
  },
  setup(__props) {

const props = __props;
  const absoluteErrorId = ref(`ari-absolute-error_${props.uid}`);
  const generateStyle = function () {
    const errorText = document.getElementById(absoluteErrorId.value);
    const errorParent = document.getElementById(props.parentContainerId);
    const isOverflowing = errorText && errorParent && errorText?.clientWidth > errorParent?.clientWidth;
    let rightValue = 0;
    if (isOverflowing) {
      return `right: calc(50% - ${errorText.clientWidth / 2}px); top: ${props.top}px;`;
    } else if (errorParent?.clientWidth > 80) return `right: ${rightValue}; top: ${props.top}px;`;
    else return 'right: 0px;';
  };

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: "ari-absolute_error",
    id: absoluteErrorId.value,
    style: normalizeStyle(generateStyle())
  }, [
    _hoisted_2$j,
    createElementVNode("span", _hoisted_3$i, toDisplayString(__props.text), 1 /* TEXT */)
  ], 12 /* STYLE, PROPS */, _hoisted_1$k))
}
}

};

script$m.__file = "src/components/Core/AbsoluteError.vue";

let uidCount = 0;

function generateUID () {
    let tmpUid = uidCount.toString();
    uidCount += 1;
    const uid = `uid-${tmpUid}`;
    return uid;
}

const AriFormProps = {
    /**
     * **AriForm.mixin**  
     * Function, Objet ou Tableau de functions / objet.  
     * Chaque function va recevoir en paramètre la valeur actuelle du component  
     * Elles doivent renvoyer le message d'erreur a afficher (String) si la validation est fausse.  
     * En cas de tableau, seule la première erreur sera stockée.  
     * Pour plus d'info voir la doc *AriForm*
     */
    formatter: [Function, Array, Object],  
    /** 
     * **AriForm.mixin**  
     * Objet renvoyé par le AriForm pour pouvoir inscrire le component au form  
     * Permet d'inscrire un component dans un form
     */
    form: Object,
    /**
     * Fonction fournit par le parent si l'on veut sanitize les valeur d'une manière spécifique (passer les null en '' pour les inputs par exemple)
     */
    customSanitizer: Function
};

function useAriForm (props, uid) {
  const inputError = ref('');
  const checkFormatter = function () {
    let myArrFormatter = [];
    let firstErrorMsg = '';
    if (props.formatter) {
      if (!Array.isArray(props.formatter)) myArrFormatter = [props.formatter];
      else myArrFormatter = [...props.formatter];
      myArrFormatter.forEach(formatter => {
        if (!firstErrorMsg) {
          if (typeof formatter === 'object' && formatter?.fx) firstErrorMsg = formatter.fx(props.modelValue, formatter.payload);
          else if (typeof formatter === 'function') firstErrorMsg = formatter(props.modelValue);
          else throw new Error('Invalid formatters prop')
        }
        inputError.value = firstErrorMsg;
      });
    } else inputError.value =  '';
    return !inputError.value;
  };
  onMounted(() => {
    if (props.form) props.form.bind({ checkFormatter: checkFormatter, uid, setFormDatas });
    setFormDatas();
  });
  onUnmounted(() => {
    if (props.form) {
      props.form.unbind(uid);
    }
  });
  watch(
    () => props.modelValue,
    (newValue) => {
      checkFormatter();
      if (props.form) props.form.modelValues[uid]['modelValue']['value'] = sanitizeValue();
    },
    { deep: true}
  );
  const setFormDatas = function () {
    if (props.form) {
      props.form.modelValues[uid] = {
        modelValue: {
          origin: sanitizeValue(),
          value: sanitizeValue()
        }
      };
    }
  };
  const sanitizeValue = function () {
    if (props.customSanitizer) return props.customSanitizer(props.modelValue);
    if (Array.isArray(props.modelValue)) return [...props.modelValue];
    else if (props.modelValue === undefined) return null;
    else return props.modelValue;
  };
  const isError = computed(() => !!inputError.value);
  return { isError, inputError, checkFormatter };
}

const _hoisted_1$j = {
  key: 0,
  class: "ari-input__decription"
};
const _hoisted_2$i = {
  key: 2,
  class: "ari-input__prefix"
};
const _hoisted_3$h = {
  key: 0,
  class: "fas fa-search"
};
const _hoisted_4$e = { key: 1 };
const _hoisted_5$b = { class: "ari-input_last-block" };
const _hoisted_6$6 = {
  key: 2,
  class: "ari-input_character-count"
};

var script$l = {
  __name: 'AriInput',
  props: {
  ...AriFormProps,
    /**
     * Placeholder qui vient se placer au dessus de l'input après focus / si il y'a un modelValue
    */
    label: {
      type: String
    },
    textarea: {
      type: Boolean
    },
    whiteBackground: Boolean,
    /**
     * Anime le label pour qu'il passe de palceholder à label dans la border
     */
    dynamicLabel: Boolean,
    /**
     * Affiche une petite description en dessous du label (fonctionne que si static)
     */
    description: String,
    /**
     * Affiche le label et l'input en row
     */
    row: Boolean,
    search: Boolean,
    type: [String, null],
    /**
     * Valeur de l'input
    */
    modelValue: [String, Number],
    /**
     * Désactive l'input
     */
    disabled: Boolean,
    /**
     * Icon de l'encart d'action à droite de l'input
     */
    actionIcon: {
      type: [String, null],
      default: null
    },
    /**
     * Centre le placeholder et le contenu de l'input
     */
    center: Boolean,
    /**
     * Aligne le placeholder et le contenu de l'input à droite
     */
    right: Boolean,
    password: Boolean,
    /**
     * Affiche un text a la fin de l'input
     */
    suffix: String,
    /**
     * Affiche un text au début de l'input
    */
     prefix: String, 
    /**
     * Temps en ms pour le debounce
     */
    debounce: {
      type: Number,
      default: 0
    },
    autofocus: Boolean,
    characters: Number,
    nativeEvent: Boolean
},
  emits: ['change', 'input', 'update:modelValue', 'action', 'focus', 'blur', 'click-suffix'],
  setup(__props, { expose: __expose, emit: __emit }) {

const uid = generateUID();
const props = __props;
const emit = __emit;
const toRefsProps = reactive(props);
const { isError, inputError, checkFormatter } = useAriForm(toRefsProps, uid);

// GESTION CSS
const currenNativetInputType = computed(() => {
  if (props.type) return props.type;
  else if (props.password && !showPassword.value) return 'password';
  else return null;
});

const inputType = computed(() => {
  if (!props.label) return 'label-less';
  if (props.inputError) return 'ari-input__error'; // Form mixin
  else return 'default';
});

const showPassword = ref(false);
const actionIconComputed = computed(() => {
  if (props.password) {
    if (!showPassword.value) return 'fa-eye';
    else return 'fa-eye-slash';
  } else return '';
});

const isFocused = ref(false);
// ACTIONS
const clickAction = function () {
  if (props.password) showPassword.value = !showPassword.value;
  else {
    emit('action');
  }
};
const myInputRef = ref(null);
const focus = function () {
  myInputRef.value?.focus();
};
// EMITS
const searchTimeout = ref(null);
const searchTimeoutChange = ref(null);
const emitUpdate = function (eventNewValue, isChange = false) {
  const targetValue = eventNewValue?.target?.value;
  const eventFired = isChange ? 'change' : 'update:modelValue';
  try {
    if (isChange && searchTimeoutChange.value) {
      clearTimeout(searchTimeoutChange.value);
    } else if (!isChange && searchTimeout.value) clearTimeout(searchTimeout.value);
    [isChange ? searchTimeoutChange : searchTimeout].value = setTimeout(async () => {
    if (targetValue || eventNewValue.data) emit(eventFired, props.nativeEvent ? eventNewValue : targetValue);
    else emit(eventFired, '');
  }, props.debounce);
  } catch(e) {
    console.log(e);
  }

};
//  Gestion characters
const currentCharacters = computed(() => {
  return props.modelValue?.length;
});

// Expose
__expose({
  isError,
  focus,
  checkFormatter
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ari-input__container", { 'ari-input__container-row': __props.row, 'ari-input__white': __props.whiteBackground }])
  }, [
    (__props.label && !__props.dynamicLabel)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["ari-input__label_static", { 'ari-input__label_static-disabled': __props.disabled }])
        }, [
          createElementVNode("span", null, toDisplayString(__props.label), 1 /* TEXT */),
          (__props.description)
            ? (openBlock(), createElementBlock("span", _hoisted_1$j, toDisplayString(__props.description), 1 /* TEXT */))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      class: normalizeClass(["ari-input", { 'ari-input__disabled': __props.disabled, 'ari-input__error': unref(isError), 'ari-input__textarea': __props.textarea, 'ari-input__with-icon': __props.search || __props.prefix }]),
      onClick: _cache[5] || (_cache[5] = withModifiers($event => (focus()), ["self"]))
    }, [
      ((__props.label && __props.dynamicLabel) || (!__props.label && !__props.modelValue))
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass({'ari-label': (__props.modelValue && __props.label) || (isFocused.value && __props.label), 'ari-placeholder-search': ((!isFocused.value || !__props.modelValue ) && __props.search),
          'ari-input__align-center': __props.center, 'ari-input__align-right': __props.right, 'ari-input__error': unref(isError), 'ari-placeholder': !isFocused.value || !__props.modelValue }),
            onClick: _cache[0] || (_cache[0] = $event => (focus()))
          }, toDisplayString(__props.label), 3 /* TEXT, CLASS */))
        : createCommentVNode("v-if", true),
      (_ctx.$slots.firstBlock)
        ? renderSlot(_ctx.$slots, "firstBlock", { key: 1 })
        : createCommentVNode("v-if", true),
      (__props.prefix || _ctx.$slots.prefix || __props.search)
        ? (openBlock(), createElementBlock("div", _hoisted_2$i, [
            (__props.search)
              ? (openBlock(), createElementBlock("i", _hoisted_3$h))
              : (__props.prefix)
                ? (openBlock(), createElementBlock("span", _hoisted_4$e, toDisplayString(__props.prefix), 1 /* TEXT */))
                : renderSlot(_ctx.$slots, "prefix", { key: 2 })
          ]))
        : createCommentVNode("v-if", true),
      (openBlock(), createBlock(resolveDynamicComponent(__props.textarea ? 'textarea' : 'input'), mergeProps(_ctx.$attrs, {
        type: currenNativetInputType.value,
        disabled: __props.disabled,
        onInput: _cache[1] || (_cache[1] = $event => (emitUpdate($event))),
        onChange: _cache[2] || (_cache[2] = $event => (emitUpdate($event, true))),
        value: __props.modelValue,
        autocomplete: _ctx.$attrs.autocomplete || 'on' ,
        class: [[inputType.value, { 'ari-input__align-center': __props.center, 'ari-input__align-right': __props.right }], "ari-input_component"],
        placeholder: _ctx.$attrs.placeholder && (!__props.label || !__props.dynamicLabel) ? _ctx.$attrs.placeholder: null,
        ref_key: "myInputRef",
        ref: myInputRef,
        autofocus: __props.autofocus,
        id: `ari-input_${unref(uid)}`,
        maxlength: __props.characters
      }), null, 16 /* FULL_PROPS */, ["type", "disabled", "value", "autocomplete", "class", "placeholder", "autofocus", "id", "maxlength"])),
      createElementVNode("div", _hoisted_5$b, [
        (actionIconComputed.value)
          ? (openBlock(), createElementBlock("div", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = $event => (clickAction())),
              class: normalizeClass(["cursorMimine", { 'action-icon': (actionIconComputed.value && !__props.password)}])
            }, [
              ((__props.actionIcon && __props.actionIcon.length > 0) || __props.password)
                ? (openBlock(), createElementBlock("i", {
                    key: 0,
                    class: normalizeClass(["ariInput-icon cursor-pointer fas", actionIconComputed.value])
                  }, null, 2 /* CLASS */))
                : createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : createCommentVNode("v-if", true),
        (__props.suffix || _ctx.$slots.suffix)
          ? (openBlock(), createElementBlock("span", {
              key: 1,
              class: "ari-input__suffix",
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('click-suffix')))
            }, [
              (__props.suffix)
                ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createTextVNode(toDisplayString(__props.suffix), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : renderSlot(_ctx.$slots, "suffix", { key: 1 })
            ]))
          : createCommentVNode("v-if", true),
        (__props.characters)
          ? (openBlock(), createElementBlock("span", _hoisted_6$6, toDisplayString(currentCharacters.value) + " / " + toDisplayString(__props.characters), 1 /* TEXT */))
          : createCommentVNode("v-if", true),
        (_ctx.$slots.lastBlock)
          ? renderSlot(_ctx.$slots, "lastBlock", { key: 3 })
          : createCommentVNode("v-if", true)
      ]),
      withDirectives(createVNode(script$m, {
        text: unref(inputError),
        uid: unref(uid),
        parentContainerId: 'ari-input_' + unref(uid)
      }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
        [vShow, unref(isError)]
      ])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

};

script$l.__file = "src/components/Ari-Input/AriInput.vue";

var script$k = {
  name: 'AriTable',
  data () {
    return {
      showFilters: true,
      revealHiddenBloc: [null, null],
      revealAllHidenBlock: false
    };
  },
  props: {
    /** 
     * Fonction qui prend en paramètre un objet qui sont les infos de la row et qui doit retourner un string qui correspond à la classe à ajouter.
     */
    formatClass: {
      type: Function,
      default: () => {}
    },
    /**
     * Tableau d'objet pour formater les colonnes.
     */
    columnsDatas: {
      type: Array,
      required: true
    },
    /**
     * Définie si les row sont selectable ou non.
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * Définie si les row possèdent la classe cursor: pointer;
     */
    showPointer: {
      type: Boolean,
      default: false
    },
    /**
     * Tableau d'objet pour chaque row
     */
    rowDatas: {
      type: Array
    },
    /**
     * Colonne en cours de trie.
     */
    activeCaret: {
      type: Object
    },
    /**
     * Met en valeur la row hovered
     */
    highlightSelectedLine: {
      type: Boolean,
      default: true
    },
    /**
     * Désactive le scroll interne au tableau
     */
    noScroll: {
      type: Boolean,
      default: false
    },
    /**
     * Ajoute une ombre au tableau
     */
    showShadowTable: {
      type: Boolean,
      default: true
    },
    /**
     * Tableau de stockage de la multi-selection. Fonctionne de pair avec selectable
     */
    multipleSelection: {
      type: Array
    },
    /**
     * Ajoute les dividers
     */
    showDividers: {
      type: Boolean,
      default: true
    },
    /**
     * Color une ligne sur deux pour gagner en visibilité
     */
    striped: {
      type: Boolean,
      default: true
    },
    /**
     * Affiche les données du tableau sur un hover
     */
    blurContentLabel: {
      type: String
    },
    /**
     * Affiche une phrase, marche uniquement avec blurContentLabel
     */
    showPhrase: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Affiche une phrase, marche uniquement avec blurContentLabel
     */
    phraseToShow: {
      type: String,
      required: false,
    },
    /**
     * Nombre de ligne dans le tableau
    */
    nbLine: {
      type: Number
    },
    /**
     * Colore l'Header du tableau dans le thème du club
    */
    useCustomColorHeader: Boolean,
    /**
     * Affiche un loader
     */
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate (value, options) {
      if (!value) return '';
      try {
        const localDate = new Date(value);
        if (!options) {
          options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          };
        }
        try {
          return new Intl.DateTimeFormat('default', options).format(localDate);
        } catch (err) {
          // Si le navigateur n'a pas de locale 'default' il levera une erreur, on met donc un fallback sur fr !!
          return new Intl.DateTimeFormat('fr', options).format(localDate);
        }
      } catch (err) {
        throw new Error(`Value parameter is not a valid timestamp string or unix timestamp! (${value})`);
      }
    },
    mouseOverHiddenBloc (indexRow, indexCell) {
      if ((indexRow || indexRow === 0) && (indexCell || indexCell === 0)) this.revealHiddenBloc = [indexRow, indexCell];
      else this.revealHiddenBloc = [null, null];
    },
    onClickLabel (objLabel) {
      if (objLabel.sortable) {
        if (this.activeCaret.label === objLabel.label) {
          switch (this.activeCaret.value) {
            case 'ascending':
              objLabel.value = 'descending';
              break;
            case 'descending':
              objLabel = {};
              break;
            default:
              objLabel = {};
          }
        } else {
          objLabel.value = 'ascending';
        }
        this.$emit('update:activeCaret', objLabel);
      }
    },
    clickCheckbox (data) {
      if (this.multipleSelection.find(row => row.id === data.id)) {
        this.$emit('update:multipleSelection', this.multipleSelection.filter((row) => row.id !== data.id));
      } else {
        const tmpArr = [...this.multipleSelection];
        tmpArr.push(data);
        this.$emit('update:multipleSelection', tmpArr);
      }
    },
    clickSelectAll () {
      if (this.allCheckboxSelected) {
        this.$emit('update:multipleSelection', []);
      } else {
        const tmpArr = [];
        this.computedRowDatas.forEach(row => tmpArr.push(row));
        this.$emit('update:multipleSelection', tmpArr);
      }
    },
    showProp (data, obj) {
      const prop = obj.prop;
      let res = '';
      if (!prop) {
        console.error('Label doesn\'t have prop');
      } else if (typeof prop === 'string') {
        if (prop.includes('.')) {
          let tmpRes = data;
          try {
            prop.split('.').forEach(p => {
              tmpRes = tmpRes[p] || '';
            });
          } catch {
            tmpRes = '';
            console.error(`Une erreur est arrivée pendant le parcours de ${data} avec les props ${prop}`);
          }
          res = tmpRes;
        } else {
          res = data[prop];
        }
      } else if (typeof prop === 'object' && prop.length) {
        if (prop.length > 1) {
          let tmpRes = data;
          try {
            prop.forEach(p => {
              tmpRes = tmpRes[p];
            });
          } catch {
            tmpRes = '';
            console.error(`Une erreur est arrivée pendant le parcours de ${data} avec les props ${prop}`);
          }
          res = tmpRes;
        } else {
          res = data[prop[0]];
        }
      }
      if (obj.date) {
        res = this.formatDate(res);
      } else if (obj.datewithday) {
        res = this.formatDate(res, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          weekday: 'long'
        });
      } else if (obj.datetime) {
        res = this.formatDate(res, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric'
        });
      }
      return res;
    }
  },
  computed: {
    computedRowDatas () {
      return this.rowDatas || [];
    },
    allCheckboxSelected () {
      return this.multipleSelection.length === this.computedRowDatas.length && !!this.multipleSelection.length;
    },
    gridTemplateColumn () {
      let css = '';
      if (this.selectable) css += 'minmax(30px, 0.1fr)';
      this.columnsDatas.forEach(() => {
        css += 'minmax(max-content, auto)';
      });
      return { gridTemplateColumns: css };
    }
  }
};

const _hoisted_1$i = {
  key: 1,
  class: "ari-font-medium absolute floatingLabel"
};
const _hoisted_2$h = { class: "blurred-content-shape" };
const _hoisted_3$g = {
  key: 2,
  class: "flex ari-font-light ariane-text-secondary text-sm nb-line-wrapper justify-end pr-xs"
};
const _hoisted_4$d = { class: "span-line" };
const _hoisted_5$a = {
  key: 0,
  class: "checkboxwidth forceCenter"
};
const _hoisted_6$5 = ["value"];
const _hoisted_7$5 = ["onClick"];
const _hoisted_8$5 = {
  key: 0,
  class: "fas fa-eye-slash"
};
const _hoisted_9$3 = {
  key: 1,
  class: "fas fa-eye"
};
const _hoisted_10$2 = ["title"];
const _hoisted_11$2 = ["title"];
const _hoisted_12$1 = {
  key: 1,
  class: "flex flex-col ari-sort-block"
};
const _hoisted_13 = { class: "scroll fg-1 h-0" };
const _hoisted_14 = {
  key: 0,
  class: "absolute centerTextAbsolute"
};
const _hoisted_15 = {
  key: 1,
  class: "content"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["value", "onChange"];
const _hoisted_18 = ["onClick", "onMouseover"];
const _hoisted_19 = {
  key: 0,
  class: "hidden-block"
};
const _hoisted_20 = /*#__PURE__*/createElementVNode("i", { class: "fas fa-lock pr-xxs" }, null, -1 /* HOISTED */);
const _hoisted_21 = {
  key: 1,
  class: "tableCell truncate w-full"
};
const _hoisted_22 = ["title"];

function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["overflow-hidden w-full flex flex-col gap-md", { relative: $props.blurContentLabel }])
  }, [
    ($data.showFilters)
      ? renderSlot(_ctx.$slots, "bar", { key: 0 })
      : createCommentVNode("v-if", true),
    (!!$props.blurContentLabel)
      ? (openBlock(), createElementBlock("div", _hoisted_1$i, [
          createElementVNode("div", _hoisted_2$h, [
            createElementVNode("span", null, toDisplayString($props.blurContentLabel), 1 /* TEXT */)
          ])
        ]))
      : createCommentVNode("v-if", true),
    ($props.noScroll)
      ? (openBlock(), createElementBlock("div", _hoisted_3$g, [
          createElementVNode("span", _hoisted_4$d, toDisplayString(_ctx.$ariane.lang.translate('tableServer.nbLine')), 1 /* TEXT */),
          createTextVNode(" " + toDisplayString($props.nbLine), 1 /* TEXT */)
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("table", {
      class: normalizeClass(["ari-table w-full-margin padding-5-no-bottom grid-template-column-responsive fg-1 floux-table-style scroll", {relative : $props.showPhrase || $props.isLoading || $options.computedRowDatas.length === 0, 'h0': !$props.noScroll,
                    blurContent: $props.blurContentLabel, 'shadow-table': $props.showShadowTable }]),
      style: normalizeStyle($options.gridTemplateColumn)
    }, [
      createElementVNode("thead", null, [
        createElementVNode("tr", null, [
          ($props.selectable)
            ? (openBlock(), createElementBlock("th", _hoisted_5$a, [
                ($props.multipleSelection)
                  ? (openBlock(), createElementBlock("input", {
                      key: 0,
                      type: "checkbox",
                      value: $options.allCheckboxSelected,
                      onChange: _cache[0] || (_cache[0] = $event => ($options.clickSelectAll($event))),
                      title: "Selectionner toutes les lignes"
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6$5))
                  : createCommentVNode("v-if", true)
              ]))
            : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.columnsDatas, (column, indexCol) => {
            return (openBlock(), createElementBlock("th", {
              onClick: $event => ($options.onClickLabel({ sortable: column.sortable, label: column.label, prop: column.prop || column.slot })),
              key: indexCol,
              class: normalizeClass(["flex gap-xxs0", { 'custom-color-header': $props.useCustomColorHeader }])
            }, [
              (column.hidden)
                ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "icon-eye ari-block-hidden",
                    onClick: _cache[1] || (_cache[1] = withModifiers($event => ($data.revealAllHidenBlock = !$data.revealAllHidenBlock), ["stop"]))
                  }, [
                    (!$data.revealAllHidenBlock)
                      ? (openBlock(), createElementBlock("i", _hoisted_8$5))
                      : (openBlock(), createElementBlock("i", _hoisted_9$3))
                  ]))
                : createCommentVNode("v-if", true),
              createElementVNode("span", {
                title: column.title || column.label,
                class: normalizeClass(["label-title ubuntuRegular truncate", (column.sortable && $props.activeCaret && $props.activeCaret.label === column.label ? ' sortedLabel ' : ' label-default-color ') + (column.sortable ? ' cursorMimine sortableLabel ' : '')])
              }, [
                createTextVNode(toDisplayString(column.label) + " ", 1 /* TEXT */),
                (column.showInfo && column.infoLabel)
                  ? (openBlock(), createElementBlock("i", {
                      key: 0,
                      title: column.infoLabel,
                      class: "fa fa-info-circle"
                    }, null, 8 /* PROPS */, _hoisted_11$2))
                  : createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_10$2),
              (column.sortable && $props.activeCaret)
                ? (openBlock(), createElementBlock("div", _hoisted_12$1, [
                    createElementVNode("i", {
                      class: normalizeClass(["caret-icon fas fa-caret-up flex", ($props.activeCaret.label === column.label && 'ascending' === $props.activeCaret.value ? 'actif' : '')])
                    }, null, 2 /* CLASS */),
                    createElementVNode("i", {
                      class: normalizeClass(["caret-icon fas fa-caret-down flex", ($props.activeCaret.label === column.label && 'descending' === $props.activeCaret.value ? 'actif' : '')])
                    }, null, 2 /* CLASS */)
                  ]))
                : createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_7$5))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      createElementVNode("tbody", _hoisted_13, [
        ($props.showPhrase || $options.computedRowDatas.length === 0)
          ? (openBlock(), createElementBlock("div", _hoisted_14, toDisplayString($props.phraseToShow), 1 /* TEXT */))
          : (openBlock(), createElementBlock("div", _hoisted_15, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.computedRowDatas, (row, indexRow) => {
                return (openBlock(), createElementBlock("tr", {
                  key: indexRow,
                  onClick: $event => (_ctx.$emit('click-row', row)),
                  class: normalizeClass({ selected: $props.selectable && !!($props.multipleSelection.find(ms => row.id === ms.id)),
                        highlightSelectedLine: $props.highlightSelectedLine, cursorMimine: $props.showPointer, [$props.formatClass({ row })]: true })
                }, [
                  ($props.selectable)
                    ? (openBlock(), createElementBlock("td", {
                        key: 0,
                        class: normalizeClass(["checkboxwidth forceCenter", { [$props.formatClass({ row })]: true, lastRow: $props.showDividers && indexRow === $options.computedRowDatas.length -1, striped: $props.striped, 'tableRow firstCell': $props.showDividers }])
                      }, [
                        createElementVNode("input", {
                          type: "checkbox",
                          class: "tableCell",
                          value: !!($props.multipleSelection.find(ms => row.id === ms.id)),
                          onChange: $event => ($options.clickCheckbox(row)),
                          title: "Sélectionner cette ligne"
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17)
                      ], 2 /* CLASS */))
                    : createCommentVNode("v-if", true),
                  (openBlock(true), createElementBlock(Fragment, null, renderList($props.columnsDatas, (cell, indexCell) => {
                    return (openBlock(), createElementBlock("td", {
                      key: indexCell,
                      onClick: $event => ($options.mouseOverHiddenBloc(indexRow, indexCell)),
                      onMouseover: $event => ($options.mouseOverHiddenBloc(indexRow, indexCell)),
                      onMouseleave: _cache[2] || (_cache[2] = $event => ($options.mouseOverHiddenBloc())),
                      class: normalizeClass({ firstCell: indexCell === 0 && !$props.selectable, lastRow: indexRow === $options.computedRowDatas.length -1, tableRow: $props.showDividers,
                          borderos: $props.activeCaret && $props.activeCaret.prop === cell.prop && $props.activeCaret.prop, striped: $props.striped, [$props.formatClass({ row, cell })]: true })
                    }, [
                      (!$data.revealAllHidenBlock && cell.hidden && !($data.revealHiddenBloc[0] === indexRow && $data.revealHiddenBloc[1] === indexCell))
                        ? (openBlock(), createElementBlock("div", _hoisted_19, [
                            _hoisted_20,
                            createTextVNode(" " + toDisplayString(_ctx.$ariane.lang.translate('tablegrid.hoverToReveal')), 1 /* TEXT */)
                          ]))
                        : createCommentVNode("v-if", true),
                      (cell.slot)
                        ? (openBlock(), createElementBlock("span", _hoisted_21, [
                            renderSlot(_ctx.$slots, cell.slot, { data: row })
                          ]))
                        : (cell.prop)
                          ? (openBlock(), createElementBlock("span", {
                              key: 2,
                              class: "tableCell truncate",
                              title: $options.showProp(row, cell)
                            }, toDisplayString($options.showProp(row, cell)), 9 /* TEXT, PROPS */, _hoisted_22))
                          : createCommentVNode("v-if", true)
                    ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_18))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 10 /* CLASS, PROPS */, _hoisted_16))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
      ])
    ], 6 /* CLASS, STYLE */)
  ], 2 /* CLASS */))
}

script$k.render = render$d;
script$k.__file = "src/components/Ari-Table/ari-table.vue";

class Resize {
  // Observable singleton pour ne créer qu'un seul eventListener Resize.
  // https://www.sitepoint.com/javascript-design-patterns-observer-pattern/
  constructor () {
    if (Resize.instance) {
      return Resize.instance;
    } else {
      this.observers = [];
      window.addEventListener('resize', () => {
        this.broadcast();
      });
    }
  }

  /**
   * subscribe - Subscribe a l'eventListener
   *
   * @param  {type} obj id: uid du component, callback: callback une fois l'event proc
   */
  subscribe (obj) {
    this.observers.push(obj);
  }

  /**
   * unsubscribe - Desinscrit de l'event Listener
   * @param  {type} uid uid du component
   * @return {type}     description
   */
  unsubscribe (uid) {
    this.observers = this.observers.filter((subscriber) => subscriber.id !== uid);
  }

  /**
   * broadcast - Fonction appelée lors du proc de l'eventListener
   * joue tous les callback dans le tableau observers
   */
  broadcast () {
    try {
      this.observers.forEach((subscriber) => subscriber.fx());
    } catch (e) {
      console.log(e);
    }
  }
}

// https://gist.github.com/Loilo/73c55ed04917ecf5d682ec70a2a1b8e2 Pour bien comprendre le coup des slots scopes
var script$j = {
  name: 'AriTableServer',
  props: {
    // PROPS TableServer
    filters: {
      type: Array,
      required: false
    },
    fetchData: {
      type: Function,
      required: false
    },
    manualDatas: {
      type: Array,
      required: false
    },
    manualNbRows: {
      type: Number,
      required: false
    },
    manualPage: {
      type: Number,
      required: false
    },
    nbRowAvailablePerPage: {
      type: Array,
      required: false
    },
    // PROPS TableFlex
    /**
     * Voir tableFlex pour la doc
     */
    includeMetaData: {
      type: Boolean,
      default: false
    },
    defaultSelectState: {
      type: Boolean,
      default: false
    },
    multipleSelection: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      resizeListener: new Resize(), // On le met dans data pour pouvoir facilement unsubscribe au destroy
      tableDatas: [],
      nbRows: 0,
      arrNbRowsAvailable: [20, 40, 80, 100],
      page: 1,
      nbPerPage: 20,
      activeCaret: {},
      isLoading: false,
      previousFilters: {}
    };
  },
  computed: {
    rowPerPage () {
      return this.nbRowAvailablePerPage ? this.nbRowAvailablePerPage : this.arrNbRowsAvailable;
    },
    maxRows () {
      return this.manualDatas ? this.manualDatas.length : this.nbRows;
    },
    showPhrase () {
      return !this.isLoading && !this.tableDatas.length;
    }
  },
  mounted () {
    this.fillTableDatas();
    this.nbPerPage = this.rowPerPage[0];
    const fx = () => {
      this.windowWidth = window.innerWidth;
    };
    this.resizeListener.subscribe({ id: this._uid, fx });
  },
  methods: {
    changeNbPerPage (newPerPage) {
      this.page = 1;
      this.nbPerPage = newPerPage;
    },
    changePage (newPage) {
      this.page = newPage;
      this.fillTableDatas();
    },
    needToIncludeMetadata (aggregatedFilters) {
      let willIncludeMetadata = false;
      const currentFilters = { ...aggregatedFilters };
      delete currentFilters.page;
      delete currentFilters.per_page;
      delete currentFilters.prop;
      delete currentFilters.order;
      delete currentFilters.includeMetadata;

      if (JSON.stringify(this.previousFilters) !== JSON.stringify(currentFilters)) {
        willIncludeMetadata = true;
      }

      this.previousFilters = currentFilters;

      return willIncludeMetadata;
    },
    fillTableDatas () {
      if (this.fetchData) {
        if (this.isLoading) {
          setTimeout(() => this.fillTableDatas(), 125);
        } else {
          this.isLoading = true;
          let aggregatedFilters = this.filters ? [...this.filters] : [];
          aggregatedFilters.push({ prop: 'page', value: this.page });
          aggregatedFilters.push({ prop: 'per_page', value: this.nbPerPage });
          if (this.activeCaret.label) {
            let propSortValue = '';
            if (Array.isArray(this.activeCaret.prop)) {
              propSortValue = this.activeCaret.prop.join('.');
            } else if (typeof this.activeCaret.prop === 'string') {
              propSortValue = this.activeCaret.prop;
            }
            aggregatedFilters.push({ prop: 'prop', value: propSortValue });
            aggregatedFilters.push({ prop: 'order', value: this.activeCaret.value });
          }
          aggregatedFilters = aggregatedFilters.reduce((accumulator, filter) => {
            const valueIsValid = (filter?.value || filter?.value === 0) && filter?.value !== '';
            if (filter?.prop && valueIsValid) {
              accumulator[filter.prop] = filter.value;
            }
            return accumulator;
          }, {});
          if (this.includeMetaData && this.needToIncludeMetadata(aggregatedFilters)) {
            aggregatedFilters.includeMetadata = 1;
          }
          this.fetchData(aggregatedFilters).then(res => {
            if (res.data.metadata) {
              this.$emit('changeMetadata', res.data.metadata);
            }
            this.nbRows = res.data.count;
            this.tableDatas = res.data.rows;
            this.isLoading = false;
          }).catch(() => {
            this.isLoading = false;
            this.$notify({
              type: 'warning',
              title: 'app.error',
              message: 'app.errorOccurred'
            });
          });
        }
      } else {
        this.tableDatas = this.manualDatas;
      }
    }
  },
  watch: {
    activeCaret () {
      this.fillTableDatas();
    },
    nbPerPage () {
      this.fillTableDatas();
    },
    filters: {
      handler () {
        this.page = 1;
        this.fillTableDatas();
      },
      deep: true
    },
    page () {
      this.fillTableDatas();
    },
    datas: {
      handler () {
        this.fillTableDatas();
      },
      deep: true
    },
    manualDatas () {
      this.fillTableDatas();
    },
    fetchData: {
      handler () {
        this.fillTableDatas();
      },
      deep: true
    }
  },
  beforeDestroy () {
    this.resizeListener.unsubscribe(this._uid);
  }
};

const _hoisted_1$h = { class: "flex flex-col h-full" };
const _hoisted_2$g = { class: "margin-5-no-top pt-xxs ffffff radius shadowbox" };
const _hoisted_3$f = { class: "flex w-full items-center" };
const _hoisted_4$c = { class: "flex items-center bloc-page f-equal ari-font-light ariane-text-secondary text-sm" };
const _hoisted_5$9 = { class: "span-line-per-page" };
const _hoisted_6$4 = { key: 0 };
const _hoisted_7$4 = { class: "flex f-equal ariane-text-secondary text-sm nb-line-wrapper" };
const _hoisted_8$4 = { class: "span-line" };

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriTable = resolveComponent("AriTable");
  const _component_AriPagePicker = resolveComponent("AriPagePicker");

  return (openBlock(), createElementBlock("div", _hoisted_1$h, [
    createVNode(_component_AriTable, mergeProps(_ctx.$attrs, {
      rowDatas: $data.tableDatas,
      isLoading: $data.isLoading,
      onClickRow: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click-row', $event))),
      showPhrase: $options.showPhrase,
      activeCaret: $data.activeCaret,
      multipleSelection: $props.multipleSelection,
      noScroll: "",
      "onUpdate:multipleSelection": _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:multipleSelection', $event))),
      class: "fg-1",
      nbLine: $options.maxRows
    }), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.$scopedSlots, (_, name) => {
          return renderSlot(_ctx.$slots, name, mergeProps({ ref_for: true }, _ctx.slotData))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["rowDatas", "isLoading", "showPhrase", "activeCaret", "multipleSelection", "nbLine"]),
    createElementVNode("div", _hoisted_2$g, [
      createElementVNode("div", _hoisted_3$f, [
        createElementVNode("span", _hoisted_4$c, [
          createElementVNode("span", _hoisted_5$9, toDisplayString(_ctx.$ariane.lang.translate('tableServer.linePerPage')), 1 /* TEXT */),
          ($options.rowPerPage.length === 1 )
            ? (openBlock(), createElementBlock("span", _hoisted_6$4, toDisplayString($options.rowPerPage[0]), 1 /* TEXT */))
            : createCommentVNode("v-if", true),
          createCommentVNode(" <FlouxDropdown v-else fullSize :small=\"windowWidth > 1000\" class=\"w-full\" :datas=\"rowPerPage\" :modelValue=\"nbPerPage\" @update:modelValue=\"changeNbPerPage($event)\"\r\n                         :mini=\"windowWidth < 1001\" :customLabelKey=\"null\" :customValueKey=\"null\" :clearable=\"false\"/> ")
        ]),
        createVNode(_component_AriPagePicker, {
          page: $data.page,
          nbRows: $options.maxRows,
          nbPerPage: $data.nbPerPage,
          class: "f-equal justify-content-center page-picker-wrapper"
        }, null, 8 /* PROPS */, ["page", "nbRows", "nbPerPage"]),
        createElementVNode("div", _hoisted_7$4, [
          createElementVNode("span", _hoisted_8$4, toDisplayString(_ctx.$ariane.lang.translate('tableServer.nbLine')), 1 /* TEXT */),
          createTextVNode(" " + toDisplayString($options.maxRows), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}

script$j.render = render$c;
script$j.__file = "src/components/Ari-TableServer/ari-table-server.vue";

var script$i = {
  name: 'AriPagePicker',
  props: {
    /**
     * Nombre de Ligne au total
     */
    nbRows: {
      type: Number,
      required: true
    },
    /**
     * Page actuel
     */
    page: {
      type: Number,
      required: true
    },
    /**
     * Nombre de ligne par page
     */
    nbPerPage: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      resizeListener: new Resize(),
      nbPerRow: 20,
      valueInput: null,
    };
  },
  computed: {
    pagePickerType () {
      let type = 1;
      if (this.windowWidth < 768) {
        type = 4;
      } else if (this.maxPage > 9) {
        if (this.page - 3 < 1 || this.calculateLastNumber(3).includes(this.page)) {
          type = 2;
        } else {
          type = 3;
        }
      }
      return type;
    },
    calculateAdjacentNumbersOfCurrentPage () {
      const adjacentNumbers = [];
      for (let i = 0; i < 5; i++) {
        adjacentNumbers.push(this.page - 2 + i);
      }
      return adjacentNumbers;
    },
    maxPage () {
      return Math.ceil(this.nbRows / this.nbPerPage);
    }
  },
  mounted () {
    const fx = () => {
      this.windowWidth = window.innerWidth;
    };
    this.resizeListener.subscribe({ id: this._uid, fx });
  },
  beforeDestroy () {
    this.resizeListener.unsubscribe(this._uid);
  },
  methods: {
    changePageValue (newValue) {
      this.$emit('update:page', newValue);
    },
    changeInputValue (event) {
      if (Number.isInteger(event) && event > 0) {
        if (event > this.maxPage) this.changePageValue(this.maxPage);
        else this.changePageValue(event);
      } else this.changePageValue(1);
      this.valueInput = null;
    },
    calculateLastNumber (lastX) {
      const lastNumber = [];
      for (let i = lastX; i > 0; i--) {
        lastNumber.push(this.maxPage - i + 1);
      }
      return lastNumber;
    },
    clickCarret (incrDecr) {
      let newValue = this.page + incrDecr;
      if (this.page + incrDecr > this.maxPage) newValue = this.maxPage;
      else if (this.page + incrDecr < 1) newValue = 1;
      this.changePageValue(newValue);
    }
  }
};

const _hoisted_1$g = { class: "ari-pagination" };
const _hoisted_2$f = {
  key: 0,
  class: "ari-pagination-left"
};
const _hoisted_3$e = { class: "ari-pagination-center-container" };
const _hoisted_4$b = ["onClick"];
const _hoisted_5$8 = ["onClick"];
const _hoisted_6$3 = ["onClick"];
const _hoisted_7$3 = ["onClick"];
const _hoisted_8$3 = {
  key: 1,
  class: "ari-pagination-right"
};

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriInputNumber = resolveComponent("AriInputNumber");

  return (openBlock(), createElementBlock("div", _hoisted_1$g, [
    ($options.pagePickerType > 1)
      ? (openBlock(), createElementBlock("div", _hoisted_2$f, [
          createElementVNode("i", {
            onClick: _cache[0] || (_cache[0] = $event => ($options.changePageValue(1))),
            class: normalizeClass(["fas fa-angle-double-left ari-double-angle-left", { 'ari-page-picker-disabled': $props.page === 1 }])
          }, null, 2 /* CLASS */),
          createElementVNode("i", {
            onClick: _cache[1] || (_cache[1] = $event => ($options.clickCarret(-1))),
            class: normalizeClass(["fas fa-angle-left ari-single-angle-left", { 'ari-page-picker-disabled': $props.page === 1 }])
          }, null, 2 /* CLASS */)
        ]))
      : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_3$e, [
      ($options.pagePickerType === 1)
        ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList($options.maxPage, (index) => {
            return (openBlock(), createElementBlock("span", {
              onClick: $event => (_ctx.$emit('update:page', index)),
              key: index,
              class: normalizeClass(["ari-pagination-button", { 'ari-page-picker-selected': $props.page === index }])
            }, toDisplayString(index), 11 /* TEXT, CLASS, PROPS */, _hoisted_4$b))
          }), 128 /* KEYED_FRAGMENT */))
        : createCommentVNode("v-if", true),
      ($options.pagePickerType === 2)
        ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            (openBlock(), createElementBlock(Fragment, null, renderList(4, (index) => {
              return createElementVNode("span", {
                onClick: $event => (_ctx.$emit('update:page', index)),
                key: index,
                class: normalizeClass(["ari-pagination-button", { 'ari-page-picker-selected': $props.page === index }])
              }, toDisplayString(index), 11 /* TEXT, CLASS, PROPS */, _hoisted_5$8)
            }), 64 /* STABLE_FRAGMENT */)),
            createVNode(_component_AriInputNumber, {
              min: null,
              placeholder: "...",
              directInput: "",
              actionButtons: false,
              modelValue: $data.valueInput,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($options.changeInputValue($event))),
              class: "cleanCssInput"
            }, null, 8 /* PROPS */, ["modelValue"]),
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.calculateLastNumber(4), (numberPage) => {
              return (openBlock(), createElementBlock("span", {
                onClick: $event => (_ctx.$emit('update:page', numberPage)),
                key: numberPage,
                class: normalizeClass(["ari-pagination-button", { 'ari-page-picker-selected': $props.page === numberPage }])
              }, toDisplayString(numberPage), 11 /* TEXT, CLASS, PROPS */, _hoisted_6$3))
            }), 128 /* KEYED_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : createCommentVNode("v-if", true),
      ($options.pagePickerType === 3)
        ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
            createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('update:page', 1))),
              class: normalizeClass(["ari-pagination-button", { 'ari-page-picker-selected': $props.page === 1 }])
            }, "1", 2 /* CLASS */),
            createVNode(_component_AriInputNumber, {
              min: null,
              placeholder: "...",
              directInput: "",
              actionButtons: false,
              modelValue: $data.valueInput,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ($options.changeInputValue($event))),
              class: "cleanCssInput"
            }, null, 8 /* PROPS */, ["modelValue"]),
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.calculateAdjacentNumbersOfCurrentPage, (index) => {
              return (openBlock(), createElementBlock("span", {
                onClick: $event => (_ctx.$emit('update:page', index)),
                key: index,
                class: normalizeClass(["ari-pagination-button", { 'ari-page-picker-selected': $props.page === index }])
              }, toDisplayString(index), 11 /* TEXT, CLASS, PROPS */, _hoisted_7$3))
            }), 128 /* KEYED_FRAGMENT */)),
            createVNode(_component_AriInputNumber, {
              min: null,
              placeholder: "...",
              directInput: "",
              actionButtons: false,
              modelValue: $data.valueInput,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ($options.changeInputValue($event))),
              class: "cleanCssInput"
            }, null, 8 /* PROPS */, ["modelValue"]),
            createElementVNode("span", {
              onClick: _cache[6] || (_cache[6] = $event => (_ctx.$emit('update:page', $options.maxPage))),
              class: normalizeClass(["ari-pagination-button", { 'ari-page-picker-selected': $props.page === $options.maxPage }])
            }, toDisplayString($options.maxPage), 3 /* TEXT, CLASS */)
          ], 64 /* STABLE_FRAGMENT */))
        : createCommentVNode("v-if", true),
      ($options.pagePickerType === 4)
        ? (openBlock(), createBlock(_component_AriInputNumber, {
            key: 3,
            min: null,
            placeholder: "...",
            directInput: "",
            actionButtons: false,
            modelValue: $data.valueInput,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ($options.changeInputValue($event))),
            class: "cleanCssInput"
          }, null, 8 /* PROPS */, ["modelValue"]))
        : createCommentVNode("v-if", true)
    ]),
    ($options.pagePickerType > 1)
      ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
          createElementVNode("i", {
            onClick: _cache[8] || (_cache[8] = $event => ($options.clickCarret(1))),
            class: normalizeClass(["ari-double-angle-right fas fa-angle-right", { 'ari-page-picker-disabled': $props.page === $options.maxPage }])
          }, null, 2 /* CLASS */),
          createElementVNode("i", {
            onClick: _cache[9] || (_cache[9] = $event => ($options.changePageValue($options.maxPage))),
            class: normalizeClass(["ari-single-angle-right fas fa-angle-double-right", { 'ari-page-picker-disabled': $props.page === $options.maxPage }])
          }, null, 2 /* CLASS */)
        ]))
      : createCommentVNode("v-if", true)
  ]))
}

script$i.render = render$b;
script$i.__file = "src/components/Ari-PagePicker/ari-page-picker.vue";

var script$h = {
  name: 'AriModal',
  props: {
    /**
     * Lance un event "@close" lors de l'appui sur la touche 'Echap' 
     */
    exitOnEsc: {
      type: Boolean,
      default: true
    },
    /**
     * Lance un event "@close" lors deu clique sur le masque
     */
    exitOnOutside: {
      type: Boolean,
      default: true
    },
    /** 
     * Affiche la modal a l'interieur de son parent
     */
    stucked: {
      type: Boolean
    },
    /**
     * Modifie la couleur de fond de la modal
     */
    backgroundColor: String,
    /**
     * Force la width de la modal, non effectif sur mobile (640px)
     */
    width: {
      type: [String, Number],
      default: 'auto'
    },
    /** Défini une max-width, non effectif sur mobile (640px) */
    maxWidth: {
      type: [String],
      default: '90%'
    },
    minWidth: {
      type: [String],
      default: 'auto'
    },
    /**
     * Force la height de la modal, non effectif sur mobile (640px)
     */
    height: {
      type: [String, Number],
      default: 'auto'
    },
    /**
     * Affiche une petit croix en haut a droite qui emit "@close" lors du clique
     */
    showClose: {
      type: Boolean,
      default: true
    },
    /**
     * Les modales se fixent en bas de l'ecran en mode mobile
     */
    slide: Boolean,
    /**
     * Title de la modal pour aligner la petite croix de fermeture
     */
    modalTitle: {
      type: String
    },
    simple: Boolean,
    tip: [String, Object]
  },
  mounted () {
    if (this.exitOnEsc) document.addEventListener('keydown', this.closeOnEsc);
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.closeOnEsc);
  },
  computed: {
    isSlideMobile () {
      return this.slide && window.innerWidth <= 640;
    }
  },
  methods: {
    clickOnMask () {
      if (this.exitOnOutside) this.$emit('close');
    },
    closeOnEsc (event) {
      if (event.key === 'Escape') {
        this.$emit('close');
      }
    },
    applyDynamicStyles: function () {
      let dynamicStyles = '';

      // On fixe que si !mobile
      if (window.innerWidth > 640) {
        dynamicStyles += this.width ? `width: ${this.width};` : '';
        dynamicStyles += this.height ? `height: ${this.height};` : '';
        dynamicStyles += this.maxWidth ? `max-width: ${this.maxWidth};` : ``;
        dynamicStyles += this.minWidth ? `min-width: ${this.minWidth};` : ``;
      } else if (!this.slide) {
        dynamicStyles += `max-width: 95%; width: 95%;`;
      }
      dynamicStyles += this.backgroundColor ? `background-color: ${this.backgroundColor};` : '';

      return dynamicStyles || null;
    },
  }
};

const _hoisted_1$f = { class: "ari-grid-modal" };
const _hoisted_2$e = {
  key: 0,
  class: "ari-title-header"
};
const _hoisted_3$d = { class: "modal-title" };
const _hoisted_4$a = { class: "ari-grid-modal-body-content" };
const _hoisted_5$7 = { class: "ari-grid-modal-footer" };

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_tooltip = resolveDirective("tooltip");

  return (openBlock(), createBlock(Transition, { name: "modal" }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(["modal-mask", { stucked: $props.stucked, slide: $options.isSlideMobile, 'ari-modal__simple': $props.simple }]),
        onMousedown: _cache[2] || (_cache[2] = withModifiers($event => ($options.clickOnMask()), ["self","prevent"]))
      }, [
        createElementVNode("div", {
          class: normalizeClass(["ari-modal-container", { stucked: $props.stucked }]),
          style: normalizeStyle($options.applyDynamicStyles())
        }, [
          createElementVNode("div", _hoisted_1$f, [
            createElementVNode("div", {
              class: normalizeClass(["ari-grid-modal-header", { 'ari-padding-modal': $props.modalTitle }])
            }, [
              ($props.showClose || $props.modalTitle)
                ? (openBlock(), createElementBlock("div", _hoisted_2$e, [
                    createElementVNode("div", _hoisted_3$d, [
                      createElementVNode("span", null, toDisplayString($props.modalTitle), 1 /* TEXT */),
                      renderSlot(_ctx.$slots, "tip"),
                      ($props.tip && !_ctx.$slots.tip)
                        ? withDirectives((openBlock(), createElementBlock("i", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('clickTip'))),
                            class: "fa-sharp fa-light fa-circle-info"
                          }, null, 512 /* NEED_PATCH */)), [
                            [_directive_tooltip, $props.tip]
                          ])
                        : createCommentVNode("v-if", true)
                    ]),
                    ($props.showClose)
                      ? (openBlock(), createElementBlock("i", {
                          key: 0,
                          class: "close-modal-time fas fa-times ari-modal-close-icon",
                          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
                        }))
                      : createCommentVNode("v-if", true)
                  ]))
                : createCommentVNode("v-if", true),
              renderSlot(_ctx.$slots, "header")
            ], 2 /* CLASS */),
            createElementVNode("div", {
              class: normalizeClass(["ari-grid-modal-body", { 'ari-padding-modal': !!_ctx.$slots.footer }])
            }, [
              createElementVNode("div", _hoisted_4$a, [
                renderSlot(_ctx.$slots, "body")
              ])
            ], 2 /* CLASS */),
            createElementVNode("div", _hoisted_5$7, [
              renderSlot(_ctx.$slots, "footer")
            ])
          ])
        ], 6 /* CLASS, STYLE */)
      ], 34 /* CLASS, NEED_HYDRATION */)
    ]),
    _: 3 /* FORWARDED */
  }))
}

script$h.render = render$a;
script$h.__file = "src/components/Ari-Modal/ari-modal.vue";

var script$g = {
  name: 'AriContentTitle',
  props: {
    /**
     * Titre du contenu
     */
    contentTitle: {
      type: String,
      required: true
    },
    /** Sous-titre du contenu */
    subTitle: {
      type: String,
    },
    /**
     * Ajoute un petit icon flottant (i) ayant pour title ce props
     */
    help: {
      type: String
    },
  },
  data () {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    missingMandotoryProps () {
      return !this.contentTitle;
    }
  },
  mounted () {
    if (this.missingMandotoryProps) {
      throw new Error('Missing contentTitle [AriContentTitle]');
    }
  },
  methods: {
  }
};

const _hoisted_1$e = {
  key: 0,
  class: "container-page-title"
};
const _hoisted_2$d = { class: "ari-page-title" };
const _hoisted_3$c = { class: "content-title" };
const _hoisted_4$9 = ["title"];
const _hoisted_5$6 = { class: "content-sub-title" };

function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriButton = resolveComponent("AriButton");

  return (!$options.missingMandotoryProps)
    ? (openBlock(), createElementBlock("div", _hoisted_1$e, [
        createElementVNode("div", _hoisted_2$d, [
          createElementVNode("div", null, [
            createElementVNode("span", _hoisted_3$c, toDisplayString($props.contentTitle), 1 /* TEXT */),
            withDirectives(createElementVNode("i", {
              title: $props.help,
              class: "icon-help-content-title fas fa-info-circle"
            }, null, 8 /* PROPS */, _hoisted_4$9), [
              [vShow, $props.help]
            ])
          ]),
          createElementVNode("span", _hoisted_5$6, toDisplayString($props.subTitle), 1 /* TEXT */)
        ]),
        renderSlot(_ctx.$slots, "default"),
        (_ctx.$attrs.content || _ctx.$attrs.preIcon || _ctx.$attrs.postIcon)
          ? (openBlock(), createBlock(_component_AriButton, mergeProps({
              key: 0,
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('buttonClick'))),
              outlined: ""
            }, $data.windowWidth > 1000 ? _ctx.$attrs : {}, {
              rounded: "",
              class: "action-button-title-floux",
              preIcon: _ctx.$attrs.preIcon || 'fas fa-add'
            }), null, 16 /* FULL_PROPS */, ["preIcon"]))
          : createCommentVNode("v-if", true)
      ]))
    : createCommentVNode("v-if", true)
}

script$g.render = render$9;
script$g.__file = "src/components/Ari-ContentTitle/ari-content-title.vue";

var script$f = {
  name: 'AriAvatar',
  data () {
    return {
      imgError: false
    };
  },
  methods: {
    getInitial () {
      if (this.user) {
        const getInitialArray = Array.isArray(this.user) ? this.user : this.user.trim().split(' ');
        if (getInitialArray.length > 1) return `${getInitialArray[0][0]}${getInitialArray[1][0]}`;
        else return getInitialArray[0][0];
      } else return null;

    }
  },
  computed: {
  },
  props: {
    /**
     * URL de l'image à afficher
     */
    url: String,
    /**
     * Nom ou Nom Prenom de l'utilisateur pour afficher ses initiales en cas d'url manquante
     */
    user: {
      type: [String, Array],
    },
    /**
     * Font weight des initiales
     */
    fontWeight: {
      type: Number,
      default: 500
    },
    /**
     * Taille en pixel du container (width & height)
     */
    size: {
     type: [Number, String],
     default: 50
    },
    /**
     * Force un theme noir & blanc
     */
    blackAndWhite: {
      type: Boolean,
      default: false
    }
  }
};

const _hoisted_1$d = ["src"];
const _hoisted_2$c = {
  key: 2,
  class: "fas fa-user ari-user-callback-avatar"
};

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ari-avatar", { 'black-and-white-avatar': $props.blackAndWhite }]),
    style: normalizeStyle(`width: ${$props.size}px; height: ${$props.size}px`)
  }, [
    ($props.url && !$data.imgError)
      ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: $props.url,
          class: "ari-avatar-img",
          onError: _cache[0] || (_cache[0] = $event => ($data.imgError = true))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1$d))
      : ($options.getInitial())
        ? (openBlock(), createElementBlock("span", {
            key: 1,
            class: "ari-avatar-text",
            style: normalizeStyle(`font-weight: ${$props.fontWeight}`)
          }, toDisplayString($options.getInitial()), 5 /* TEXT, STYLE */))
        : (openBlock(), createElementBlock("i", _hoisted_2$c))
  ], 6 /* CLASS, STYLE */))
}

script$f.render = render$8;
script$f.__file = "src/components/Ari-Avatar/ari-avatar.vue";

var script$e = {
  name: 'AriInputNumber_Controls',
  data () {
    return {
      fxPressed: null
    }
  },
  methods: {
    clickCaret (emit) {
      if (!this.disabled) {
        this.$emit(`click${emit}`);
        // this.fxPressed = setInterval(() => this.$emit(`click${emit}`), 250);
      }
    },
    cleanFxInterval () {
      // clearInterval(this.fxPressed)
    }
  },
  props: {
    /**
     * Désactive le component
     */
    disabled: Boolean,
    controlsLeft: {
      type: Boolean,
    },
    controlsGlobal: {
      type: Boolean,
    },
    modelValue: Number,
    min: {
      type: Number,
      default: 0
    }, 
    max: Number
  },
  computed: {
    isControlRight () {
      return !this.controlsGlobal || !this.controlsLeft;
    }
  },
};

const _hoisted_1$c = { class: "container-ari-input-number_controls" };
const _hoisted_2$b = /*#__PURE__*/createElementVNode("i", { class: "fa fa-caret-up" }, null, -1 /* HOISTED */);
const _hoisted_3$b = [
  _hoisted_2$b
];
const _hoisted_4$8 = /*#__PURE__*/createElementVNode("i", { class: "fa fa-caret-down" }, null, -1 /* HOISTED */);
const _hoisted_5$5 = [
  _hoisted_4$8
];

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1$c, [
    createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = $event => ($options.clickCaret('Up'))),
      class: normalizeClass(["ari-input-number_control",  { 'ari-input-number-disabled': (($props.max && $props.modelValue >= $props.max) || $props.disabled) }])
    }, [..._hoisted_3$b], 2 /* CLASS */),
    createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = $event => ($options.clickCaret('Down'))),
      class: normalizeClass(["ari-input-number_control",  { 'ari-input-number-disabled': (($props.min && $props.modelValue <= $props.min) || $props.disabled) }])
    }, [..._hoisted_5$5], 2 /* CLASS */)
  ]))
}

script$e.render = render$7;
script$e.__file = "src/components/Ari-InputNumber/components/ari-input-number_controls_col.vue";

var script$d = {
  name: 'MixinAriForm',
  components: { AriAbsoluteError: script$m },
  data () {
    return {
      inputError: '',
      uid: generateUID()
    };
  },
  mounted () {
    if (this.form) this.form.bind({ checkFormatter: this.checkFormatter, uid: this.uid, setFormDatas: this.setFormDatas });
    this.setFormDatas();
  },
  beforeDestroy () {
    if (this.form) {
      this.form.unbind(this.uid);
    }
  },
  computed: {
    isError () {
      return !!this.inputError;
    }
  },
  watch: {
    modelValue: {
      deep: true,
      handler (newValue) {
        this.checkFormatter(newValue);
        if (this.form) this.form.modelValues[this.uid]['modelValue']['value'] = this.sanitizeValue();
      }
    }
  },
  methods: {
    setFormDatas () {
      if (this.form) {
        this.form.modelValues[this.uid] = {
          modelValue: {
            origin: this.sanitizeValue(),
            value: this.sanitizeValue()
          }
        };
      }
    },
    sanitizeValue () {
      if (this.customSanitizer) return this.customSanitizer(this.modelValue);
      if (Array.isArray(this.modelValue)) return [...this.modelValue];
      else if (this.modelValue === undefined) return null;
      else return this.modelValue;
    },
    checkFormatter () {
      let myArrFormatter = [];
      let firstErrorMsg = '';
      if (this.formatter) {
        if (!Array.isArray(this.formatter)) myArrFormatter = [this.formatter];
        else myArrFormatter = [...this.formatter];
        myArrFormatter.forEach(formatter => {
          if (!firstErrorMsg) {
            if (typeof formatter === 'object' && formatter?.fx) firstErrorMsg = formatter.fx(this.modelValue, formatter.payload);
            else if (typeof formatter === 'function') firstErrorMsg = formatter(this.modelValue);
            else throw new Error('Invalid formatters prop')
          }
          this.inputError = firstErrorMsg;
        });
      } else this.inputError = '';
      return !this.inputError;
    },
    // emitUpdate (eventNewValue) {
    //   const { target } = eventNewValue;
    //   if (target && target.value) this.$emit('update:modelValue', target.value);
    //   else this.$emit('update:modelValue', '');
    // }
  },
  props: {
    /**
     * **AriForm.mixin**  
     * Function, Objet ou Tableau de functions / objet.  
     * Chaque function va recevoir en paramètre la valeur actuelle du component  
     * Elles doivent renvoyer le message d'erreur a afficher (String) si la validation est fausse.  
     * En cas de tableau, seule la première erreur sera stockée.  
     * Pour plus d'info voir la doc *AriForm*
     */
    formatter: [Function, Array, Object],
    /** 
     * **AriForm.mixin**  
     * Objet renvoyé par le AriForm pour pouvoir inscrire le component au form  
     * Permet d'inscrire un component dans un form
     */
    form: Object,
    /**
     * Fonction fournit par le parent si l'on veut sanitize les valeur d'une manière spécifique (passer les null en '' pour les inputs par exemple)
     */
    customSanitizer: Function
  }
};

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return null
}

script$d.render = render$6;
script$d.__file = "src/components/Ari-Form/ari-form.mixin.vue";

const _hoisted_1$b = { class: "ari-core__container" };
const _hoisted_2$a = {
  key: 0,
  class: "ari-core__label"
};
const _hoisted_3$a = {
  key: 1,
  class: "ari-core__container"
};


var script$c = {
  __name: 'Ari-CoreContainer',
  props: {
  label: String,
  description: String
},
  emits: ['blur', 'focus', 'click', 'update:modelValue', 'change', 'input', 'click-suffix', 'clickAction'],
  setup(__props, { emit: __emit }) {

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$b, [
    createElementVNode("label", null, [
      (__props.label)
        ? (openBlock(), createElementBlock("span", _hoisted_2$a, toDisplayString(__props.label), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      (__props.description)
        ? (openBlock(), createElementBlock("span", _hoisted_3$a, toDisplayString(__props.description), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

};

script$c.__file = "src/components/Core/Ari-CoreContainer.vue";

/**
 * TODO: Gérer le click long sur les contorls. Gérer le max en diect input
 */
var script$b = {
  name: 'AriInputNumber',
  components: { ariInputNumberControls: script$e, AriAbsoluteError: script$m, AriCoreContainer: script$c },
  data () {
    return {
      keyRefresh: 1
    }
  },
  mixins: [script$d],
  emits: ['update:modelValue', 'change'],
  props: {
    /**
     * Valeur de l'input (v-model)
     */
    modelValue: [Number, String],
    /**
     * Valeur maximal possible
     */
    max: {
      type: [Number, String]
    },
    isFloat: {
      type: Boolean,
      default: true
    },
    /**
     * Permet un input vide (return null)
     */
    nullable: {
      type: Boolean,
      default: false
    },
    /**
     * Valeur minimal possible
     */
    min: {
      type: [Number, String],
      default: 0
    },
    /**
     * Désactive le component
     */
    disabled: Boolean,
    /**
     * Valuer d'incrémentation ou de décrémentation après un clique sur les boutons d'action.
     */
    step: {
      type: [String, Number],
      default: 1
    },
    /**
     * Permet d'afficher un input pour entrer manuellement la valeur
     */
    directInput: Boolean,
    /**
     * Vire la border-bottom du directInput
     */
    noBorder: Boolean,
    /**
     * Affiche les controles a gauche
     */
    controlsLeft: {
      type: Boolean,
    },
    /**
     * Affiche ou non les boutons d'action, si non, passe en directInput
     */
    actionButtons: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    isControlRight () {
      return !this.controlsSplit && !this.controlsLeft;
    },
    controlsPosition () {
      return this.controlsLeft ? 'firstBlock' : 'lastBlock';
    },
  },
  watch: {
    min (newValue) {
      if (newValue >= parseFloat(this.modelValue)) this.$emit('update:modelValue', newValue);
    },
    max (newValue) {
      if (newValue <= parseFloat(this.modelValue)) this.$emit('update:modelValue', newValue);
    }
  },
  methods: {
    processInput (event, onChange = false) {
      let newValue = event?.target?.value;
      // Si c'est vide, c'est un '.'
      if (event.data === '.') {
        newValue = `${this.modelValue},`;
      }
      const isIntOnlyWithComaOrDot = !this.isFloat && newValue && (newValue.indexOf(',') !== -1 || newValue.indexOf('.') !== -1);
      if (isIntOnlyWithComaOrDot) newValue = newValue.replaceAll(',', '').replaceAll('.', '');
      const numberValue = parseFloat(newValue);
      const emitFired = onChange ? 'change' : 'update:modelValue';
      if (this.nullable && newValue.target.value === '') this.$emit(emitFired, null);
      if ((!this.max || this.max >= numberValue) && (!this.min || this.min <= numberValue) && !this.disabled) this.$emit(emitFired, numberValue);
      else this.keyRefresh++;
    },
    changeValue (step) {
      const currentValue = this.modelValue ? parseFloat(this.modelValue) : (this.min || 0);
      const isNotSup = (!this.max && this.max !== 0) || currentValue + step <= this.max;
      const isNotLower = (!this.min && this.min !== 0) || currentValue + step >= this.min;
      if (!this.disabled && isNotSup && isNotLower) {
        this.$emit('update:modelValue', currentValue + step);
        this.$emit('change', currentValue + step);
      }
    }
  }
};

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ariInputNumberControls = resolveComponent("ariInputNumberControls");
  const _component_AriInput = resolveComponent("AriInput");
  const _component_AriAbsoluteError = resolveComponent("AriAbsoluteError");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass([{ 'ari-input-number-disabled': $props.disabled, 'ari-input__error': _ctx.inputError, }, "ari-input-number-container"])
  }, [
    (openBlock(), createBlock(_component_AriInput, mergeProps({
      inputmode: "numeric",
      class: ["direct-input-ari-input-number", { 'ari-no-border-bottom': $props.noBorder }]
    }, _ctx.$attrs, {
      key: $data.keyRefresh,
      type: "number",
      nativeEvent: "",
      modelValue: $props.modelValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($options.processInput($event))),
      disabled: $props.disabled,
      step: $props.step,
      min: $props.min,
      max: $props.max
    }), {
      [$options.controlsPosition]: withCtx(() => [
        createVNode(_component_ariInputNumberControls, mergeProps(_ctx.$props, {
          onClickUp: _cache[0] || (_cache[0] = $event => ($options.changeValue($props.step))),
          onClickDown: _cache[1] || (_cache[1] = $event => ($options.changeValue(-$props.step)))
        }), null, 16 /* FULL_PROPS */)
      ]),
      _: 2 /* DYNAMIC */
    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class", "modelValue", "disabled", "step", "min", "max"])),
    withDirectives(createVNode(_component_AriAbsoluteError, {
      text: _ctx.inputError,
      uid: _ctx.uid,
      parentContainerId: 'ari-input_' + _ctx.uid
    }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
      [vShow, _ctx.isError]
    ])
  ], 2 /* CLASS */))
}

script$b.render = render$5;
script$b.__file = "src/components/Ari-InputNumber/ari-input-number.vue";

var script$a = {
  name: 'AriToggle',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  data () {
    return { isClicking: false }
  },
  components: { AriAbsoluteError: script$m },
  mixins: [script$d],
  props: {
    filled: Boolean,
    /** Label du toggle */
    label: String,
    /** Place le label a gauche de l'input, si flas,e le place a droite */
    leftLabel: {
      type: Boolean,
      default: true
    },
    useTheme: Boolean,
    /**
     * Value du toggle
     */
    modelValue: [Boolean, String],
    /**
     * Désactive le toggle
     */
    disabled: Boolean,
    /**
     * utilise le data-theme parent
     */
    useDataTheme: Boolean,
    /**
     * Objet pour renvoyer et utiliser des valeurs différentes de true / false.    
     * Possède une valeur true et une valeur false.  
     * Le component emit-era customValue.true ou customValue.false en fonction de l'etat du toggle.
     */
    customValues: Object,
    /**
     * Met le toggle aux couleurs valid
     */
    valid: Boolean
  },
  computed: {
    withCustomValues () {
      return !!(this.customValues?.false && this.customValues?.true);
    },
    isChecked () {
      if (this.withCustomValues) {
        return this.modelValue === this.customValues.true;
      } else return this.modelValue;
    }
  },
  methods: {
    clickToggle () {
      if (!this.disabled) {
        this.checkFormatter(!this.modelValue);
        if (this.withCustomValues) this.$emit('update:modelValue', this.customValues.true === this.modelValue ? this.customValues.false : this.customValues.true);
        else this.$emit('update:modelValue', !this.modelValue);
      }
    }
  }
};

const _hoisted_1$a = { class: "ari-toggle" };
const _hoisted_2$9 = ["for"];
const _hoisted_3$9 = ["id"];
const _hoisted_4$7 = ["id", "checked"];
const _hoisted_5$4 = ["for"];

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriAbsoluteError = resolveComponent("AriAbsoluteError");

  return (openBlock(), createElementBlock("div", _hoisted_1$a, [
    ($props.leftLabel && $props.label)
      ? (openBlock(), createElementBlock("label", {
          key: 0,
          for: _ctx.uid,
          class: "ari-toggle__label",
          onMousedown: _cache[0] || (_cache[0] = $event => ($data.isClicking= true)),
          onMouseup: _cache[1] || (_cache[1] = $event => ($data.isClicking= false)),
          onMouseleave: _cache[2] || (_cache[2] = $event => ($data.isClicking= false))
        }, [
          createTextVNode(toDisplayString($props.label) + " ", 1 /* TEXT */),
          (!$props.label)
            ? renderSlot(_ctx.$slots, "default", { key: 0 })
            : createCommentVNode("v-if", true)
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_2$9))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      class: normalizeClass(["ari-switch", { disabled: $props.disabled, 'ari-switch__filled': $props.filled, 'ari-switch__valid': $props.valid, 'ari-switch__hovered': $data.isClicking }]),
      onClick: _cache[3] || (_cache[3] = $event => ($options.clickToggle())),
      id: 'ari-toggle_' + _ctx.uid
    }, [
      createElementVNode("input", {
        id: _ctx.uid,
        type: "checkbox",
        checked: $options.isChecked
      }, null, 8 /* PROPS */, _hoisted_4$7),
      createElementVNode("span", {
        class: normalizeClass(["ari-slider ari-slider-round", { disabled: $props.disabled, 'ari-switch-data-theme': $props.useDataTheme || _ctx.$attrs['data-theme'] }])
      }, null, 2 /* CLASS */),
      withDirectives(createVNode(_component_AriAbsoluteError, {
        text: _ctx.inputError,
        uid: _ctx.uid,
        parentContainerId: 'ari-toggle_' + _ctx.uid,
        top: "20"
      }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
        [vShow, !!_ctx.inputError]
      ])
    ], 10 /* CLASS, PROPS */, _hoisted_3$9),
    (!$props.leftLabel && $props.label)
      ? (openBlock(), createElementBlock("label", {
          key: 1,
          for: _ctx.uid,
          class: "ari-toggle__label",
          onMousedown: _cache[4] || (_cache[4] = $event => ($data.isClicking= true)),
          onMouseup: _cache[5] || (_cache[5] = $event => ($data.isClicking= false)),
          onMouseleave: _cache[6] || (_cache[6] = $event => ($data.isClicking= false))
        }, [
          createTextVNode(toDisplayString($props.label) + " ", 1 /* TEXT */),
          (!$props.label)
            ? renderSlot(_ctx.$slots, "default", { key: 0 })
            : createCommentVNode("v-if", true)
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5$4))
      : createCommentVNode("v-if", true)
  ]))
}

script$a.render = render$4;
script$a.__file = "src/components/Ari-Toggle/ari-toggle.vue";

var script$9 = {
  name: 'Ariradio',
  components: { AriAbsoluteError: script$m },
  mixins: [script$d],
  data () {
    return {
      isClicking: false
    }
  },
  methods: {
  },
  computed: {
    isChecked () {
      return this.modelValue === this.value;
    }
  },
  props: {
    modelValue: [String, Boolean, Number],
    /** Disabled la radio */
    disabled: Boolean,
    value: [String, Boolean, Number],
    /** Phrase affichée à droite de la radio */
    label: String,
    /**
     * Utilise le data-theme parent
     */
    useDataTheme: Boolean,
    leftLabel: Boolean
  }
};

const _hoisted_1$9 = ["id"];
const _hoisted_2$8 = ["for"];
const _hoisted_3$8 = ["id", "checked", "disabled"];
const _hoisted_4$6 = ["for"];

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriAbsoluteError = resolveComponent("AriAbsoluteError");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ari-radio", { 'ari-radio__disabled': $props.disabled, 'ari-radio-data-theme': $props.useDataTheme || _ctx.$attrs['data-theme'],
       'ari-radio-selected': $props.modelValue}]),
    id: 'ari-radio_' + _ctx.uid
  }, [
    ($props.leftLabel)
      ? (openBlock(), createElementBlock("label", {
          key: 0,
          for: _ctx.uid,
          class: normalizeClass(["ari-radio__label", { 'ari-radio_label-checked': $options.isChecked }]),
          onMousedown: _cache[0] || (_cache[0] = $event => ($data.isClicking= true)),
          onMouseup: _cache[1] || (_cache[1] = $event => ($data.isClicking= false)),
          onMouseleave: _cache[2] || (_cache[2] = $event => ($data.isClicking= false))
        }, [
          createTextVNode(toDisplayString($props.label) + " ", 1 /* TEXT */),
          (!$props.label)
            ? renderSlot(_ctx.$slots, "default", { key: 0 })
            : createCommentVNode("v-if", true)
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2$8))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      class: normalizeClass([{ 'ari-radio-checkbox__clicked': $data.isClicking && !$props.disabled }, "ari-radio__input"])
    }, [
      createElementVNode("input", mergeProps(_ctx.$attrs, {
        id: _ctx.uid,
        type: "radio",
        checked: $options.isChecked,
        disabled: $props.disabled,
        onChange: _cache[3] || (_cache[3] = $event => (_ctx.$emit('update:modelValue', $props.value))),
        onMousedown: _cache[4] || (_cache[4] = $event => ($data.isClicking= true)),
        onMouseup: _cache[5] || (_cache[5] = $event => ($data.isClicking= false)),
        onMouseleave: _cache[6] || (_cache[6] = $event => ($data.isClicking= false))
      }), null, 16 /* FULL_PROPS */, _hoisted_3$8)
    ], 2 /* CLASS */),
    (!$props.leftLabel)
      ? (openBlock(), createElementBlock("label", {
          key: 1,
          for: _ctx.uid,
          class: normalizeClass(["ari-radio__label", { 'ari-radio_label-checked': $options.isChecked }]),
          onMousedown: _cache[7] || (_cache[7] = $event => ($data.isClicking= true)),
          onMouseup: _cache[8] || (_cache[8] = $event => ($data.isClicking= false)),
          onMouseleave: _cache[9] || (_cache[9] = $event => ($data.isClicking= false))
        }, [
          createTextVNode(toDisplayString($props.label) + " ", 1 /* TEXT */),
          (!$props.label)
            ? renderSlot(_ctx.$slots, "default", { key: 0 })
            : createCommentVNode("v-if", true)
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4$6))
      : createCommentVNode("v-if", true),
    withDirectives(createVNode(_component_AriAbsoluteError, {
      text: _ctx.inputError,
      uid: _ctx.uid,
      parentContainerId: 'ari-radio_' + _ctx.uid,
      top: "20"
    }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
      [vShow, _ctx.isError]
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1$9))
}

script$9.render = render$3;
script$9.__file = "src/components/Ari-Radio/ari-radio.vue";

var fr = {"app.select":"Sélectionner","tableServer.nbLine":"Lignes: ","tableServer.linePerPage":"Lignes par page","ariSearchBar.search":"Rechercher","dropdown.empty":"Aucune donnée","dropdown.selectAll":"Tout sélectionner","sa.denyButtonText":"Refuser","sa.cancelButtonText":"Annuler","sa.confirmButtonText":"Confirmer","sa.alertButtonText":"Compris !","sa.promptButtonText":"Valider"};

var en = {"app.select":"Select","tableServer.nbLine":"Lines","tableServer.linePerPage":"Line per page","ariSearchBar.search":"Search","dropdown.empty":"Empty data","dropdown.selectAll":"Select All","sa.denyButtonText":"No","sa.cancelButtonText":"Cancel","sa.confirmButtonText":"Confirm","sa.alertButtonText":"Ok !","sa.promptButtonText":"Confirm"};

var languages = {
  fr,
  en
};

const isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
};
const isOverflown = function ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) {
  return scrollHeight > clientHeight || scrollWidth > clientWidth;
};
const mergeDeep = (target, ...sources) => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, {
          [key]: {}
        });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, {
          [key]: source[key]
        });
      }
    }
  }
  return mergeDeep(target, ...sources);
};
/**
 * parcours l'objet data pour data[key]. Si key comporte un '.', on le parcours en fonction.
 * @param {*} data Object
 * @param {*} key String If data is a nested object, you can unwrap it with .
 * @returns 
 */
const useKey = function (data, key) {
  if (key?.includes('.') && typeof data === 'object') {
    let returnedValue = data;
    key.split('.').forEach(el => {
      if (returnedValue[el]) returnedValue = returnedValue[el];
      else return null;
    });
    return returnedValue;
  } else if (key) {
    return data[key]
  } else return data;
};

var tools = { mergeDeep, useKey, isOverflown };

let currentLang = 'fr';
let lang = { ...languages };
const translate = function (key) {
  if (lang && lang[currentLang] && lang[currentLang][key]) {
    return lang[currentLang][key];
  } else return `${currentLang}.${key}`;
};
const setCurrentLang = function (newLang) {
  if (lang[newLang]) currentLang = newLang;
  else console.warn(`Language ${newLang} doesn't exist in our datas`);
};
const mergeLanguages = function (locales) {
  lang = tools.mergeDeep(locales, lang);
};
var translationService = {
  translate,
  currentLang,
  lang,
  setCurrentLang,
  mergeLanguages
};

const _hoisted_1$8 = ["id"];
const _hoisted_2$7 = ["onMousedown"];
const _hoisted_3$7 = { class: "ari-search-bar__container-results" };
const _hoisted_4$5 = { class: "ari-search-bar__content" };
const _hoisted_5$3 = { class: "ari-search-bar__text" };
const _hoisted_6$2 = ["innerHTML"];
const _hoisted_7$2 = ["innerHTML"];
const _hoisted_8$2 = { class: "ari-search-bar__select" };
const _hoisted_9$2 = /*#__PURE__*/createElementVNode("i", { class: "fa fa-regular fa-arrow-turn-down-left" }, null, -1 /* HOISTED */);

var script$8 = {
  __name: 'AriSelectContainer',
  props: {
  modelValue: [String, Number],
  containerId: String,
  autocomplete: [Array, Function],
  inputValue: String,
  isValueLocked: Boolean,
  isInputInError: Boolean,
  showAllOnFocus: Boolean,
  customValueKey: {
    type: String,
    default: 'id'
  },
  customLabelKey: {
    type: String,
    default: 'label'
  },
  debounce: {
    type: Number,
    default: 200
  },
  clearAfterSelection: Boolean,
  showPopover: Boolean
},
  emits: ['update:modelValue', 'update:inputValue', 'update:isValueLocked', 'update:showPopover'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const useCustomLabelKey = function (value) {
  if (props.customLabelKey !== null) {
    if (typeof props.customLabelKey === 'string') return value && value[props.customLabelKey];
    else {
      return props.customLabelKey(value);
    }
  } else return value;
};
const _uid = generateUID();
const emits = __emit;
// Placement container
const dynamicId = computed(() => {
  return `ari-dropdown_${_uid}`;
});
const generatePosition = function () {
  const dropDownContainer = document.querySelector(`#${props.containerId}`);
  const dropDown = document.querySelector(`#${dynamicId.value}`);
  const dropDownContainerWidth = dropDownContainer.clientWidth;
  Object.assign(dropDown.style, {
    'min-width': `${dropDownContainerWidth}px`,
    width: 'fit-content',
    'max-width': `${dropDownContainerWidth * 1.2}px`,
    'visibility': 'hidden'
  });
  setTimeout(() => {
    computePosition(dropDownContainer, dropDown,
      {
        placement: 'bottom-center',
        middleware: [flip({fallbackAxisSideDirection: 'end'}), shift(), offset(5)]  
      }).then(({x, y}) => {
        Object.assign(dropDown.style, {
          left: `${x}px`,
          top: `${y}px`,
          visibility: 'visible',
        });
    });
  }, 250);  

};
// Gestion des resultats
const results = ref([]);
const selectSuggestion = function (suggestion) {
  emits('update:modelValue', suggestion[props.customValueKey]);
  results.value = [];
  if (props.clearAfterSelection) emits('update:inputValue', '');
  else {
    emits('update:inputValue', useCustomLabelKey(suggestion));
    emits('update:isValueLocked', true);
  }
};
const loadSuggestions = function (searchString, showAllOnFocus = false) {
  let autocompleteString = searchString;
  if(props.isValueLocked && !showAllOnFocus) {
    // Si on a déja une suggestion selectionnée
    emits('update:inputValue', '');
    emits('update:isValueLocked', false);
    results.value = [];
    emits('update:modelValue', null);
    autocompleteString = '';
  }
  setTimeout(() => {
    if (props.isInputInError) results.value = [];
    else {
      handleAutocomplete(autocompleteString);
      generatePosition();
    }
  }, 50);
};
watch(() => props.searchString, (newValue) => {
  loadSuggestions(newValue);
});
// Gestion search
const removeAccents = function (str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
const searchIndexOfResult = function (searchStr, searchedText) {
  if (!searchStr || !searchedText) return -1;
  const sanitized = (str) => {
    return removeAccents(str).toLowerCase();
  };
  return sanitized(searchedText).indexOf(sanitized(searchStr));
};
// Gestion Icones
const atleastOneIcon = computed(() => {
  return !!results.value.find(r => r.icon);
});
// Gestions options
const generateHighlightedHTML = function (value, searchInDescr = false) {
  try {
    let searchedStr = useCustomLabelKey(value);
    let hightlightIndex = value.labelIndex;
    if (searchInDescr) {searchedStr = value.description; hightlightIndex = value.descrIndex; };
    if (value && typeof hightlightIndex === 'number') {
      let newStr = "";
      const strLength = props.inputValue?.length;
      newStr += hightlightIndex > 0 ? searchedStr.substring(0, hightlightIndex) : '';
      newStr += `<span class="search-highlight">${searchedStr.substring(hightlightIndex, hightlightIndex + strLength)}</span>`;
      newStr += searchedStr.substring(hightlightIndex + strLength);
      return newStr;
    } else return searchedStr;
  } catch(err) {
    console.log(err);
  }
};
const selectSuggestionOnMounted = async function () {
  const suggestion = props.autocomplete.find(el => el[props.customValueKey] === props.modelValue);
  if (suggestion) selectSuggestion(suggestion);
};
const searchTimeout = ref();
const handleAutocomplete = async function (value) {
  if (value) {
    if (Array.isArray(props.autocomplete)) {
      results.value = [];
      try {
        props.autocomplete.forEach(element => {
        if (!element) return;

        let tmpObj = null;
        const foundInLabelIndex = searchIndexOfResult(value, useCustomLabelKey(element));
        if (foundInLabelIndex !== -1) tmpObj = {...element, labelIndex: foundInLabelIndex};
        if (element.description) {
          const foundInDescriptionIndex = searchIndexOfResult(value, element?.description);
          if (foundInDescriptionIndex !== -1) {
            if (!tmpObj) tmpObj = {...element };
            if (tmpObj?.labelIndex !== -1) tmpObj.descrIndex = foundInDescriptionIndex;
            else tmpObj = {...element, descrIndex: foundInDescriptionIndex};
          };
        };
        if (tmpObj?.labelIndex > -1) results.value.unshift(tmpObj);
        else if (tmpObj?.descrIndex > -1) results.value.push(tmpObj);
      });
      } catch (err) {
        console.log(err);
      }
    } else if (typeof props.autocomplete === 'function') {
      if (searchTimeout.value) {
        clearTimeout(searchTimeout.value);
      }
      searchTimeout.value = setTimeout(async () => results.value = await props.autocomplete(value), props.debounce);
    }
  } else if (props.showAllOnFocus) {
    results.value = props.autocomplete;
  } else {
    results.value = [];
    emits('update:modelValue', null);
    return null;
  }
};
// Gestion keyboard
const focusIndex = ref(-1);
const handleKeydown = function (e) {
  switch (e.keyCode) {
    case 13: // ENTER KEY
      if(focusIndex.value >=0) {
        selectSuggestion(results.value[focusIndex.value]);
        onBlur();
      }
      break;
    case 27: // ESC KEY
        onBlur();
      break;
    case 38:
      arrowUp();
      break;
    case 40:
      arrowDown();
      break;
    default:
      focusIndex.value = -1;
      emits('update:showPopover', true);
      break;
  }
};
const onBlur = function () {
  focusIndex.value = -1;
  emits('update:showPopover', false);
};
const arrowUp = function () {
  if(focusIndex.value >= 0) {
    focusIndex.value--;
    emits('update:showPopover', true);
  }
};
const arrowDown = function () {
  if(focusIndex.value < results.value.length - 1) {
    focusIndex.value++;
    emits('update:showPopover', true);
  }
};
onMounted(() => {
  if (props.modelValue) selectSuggestionOnMounted(props.modelValue);
  window.addEventListener('keydown', handleKeydown, null);
  document.addEventListener('wheel', generatePosition);

});
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
  document.removeEventListener('wheel', generatePosition);
});

__expose({ onBlur, loadSuggestions });

return (_ctx, _cache) => {
  return (openBlock(), createBlock(Teleport, { to: "body" }, [
    withDirectives(createElementVNode("div", {
      class: "ari-search-bar-results",
      id: dynamicId.value
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(results.value, (result, index) => {
        return (openBlock(), createElementBlock("div", {
          class: normalizeClass(["ari-search-bar-suggestion", {'ari-focused-option': index === focusIndex.value }]),
          key: result[__props.customValueKey],
          onMousedown: $event => (selectSuggestion(result))
        }, [
          createElementVNode("div", _hoisted_3$7, [
            withDirectives(createElementVNode("i", {
              class: normalizeClass(["fa-regular", result.icon])
            }, null, 2 /* CLASS */), [
              [vShow, atleastOneIcon.value]
            ]),
            createElementVNode("div", _hoisted_4$5, [
              createElementVNode("div", _hoisted_5$3, [
                createElementVNode("span", {
                  innerHTML: generateHighlightedHTML(result)
                }, null, 8 /* PROPS */, _hoisted_6$2),
                (result.description)
                  ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: "ari-search-bar__result-description",
                      innerHTML: generateHighlightedHTML(result, true)
                    }, null, 8 /* PROPS */, _hoisted_7$2))
                  : createCommentVNode("v-if", true)
              ]),
              createElementVNode("div", _hoisted_8$2, [
                _hoisted_9$2,
                createElementVNode("span", null, toDisplayString(unref(translationService).translate('app.select')), 1 /* TEXT */)
              ])
            ])
          ])
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2$7))
      }), 128 /* KEYED_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_1$8), [
      [vShow, (results.value && results.value.length > 0 && __props.showPopover && !props.isInputInError)]
    ])
  ]))
}
}

};

script$8.__file = "src/components/Core/AriSelectContainer.vue";

const _hoisted_1$7 = ["id"];
const _hoisted_2$6 = { class: "ari-search-bar__prefix" };
const _hoisted_3$6 = /*#__PURE__*/createElementVNode("i", { class: "fa-light fa-circle-xmark" }, null, -1 /* HOISTED */);
const _hoisted_4$4 = [
  _hoisted_3$6
];

var script$7 = {
  __name: 'ari-search-bar',
  props: {
    showAllOnFocus: Boolean,
    /**
     * Fix la max-width de l'input à 200px
     */
    medium: Boolean,
    /**
     * Fix la max-width de l'input à 120px
     */
    xs: Boolean,
    /**
     * Valeur de la search bar
     */
    modelValue: [String, Number],
    /** Placeholder de l'input */
    placeholder: {
      type: String,
      default: () => {
       return translationService.translate('ariSearchBar.search') 
      }
    },
},
  emits: ['update:modelValue', 'clear'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const props = __props;

const inputValue = ref(null);
const inputValueLocked = ref(false);
const showPopover = ref(false);
const _uid = generateUID();

const containerDynamicId  = computed(() => {
  return `ari-dropdown-container_${_uid.value}`;
});

const selectContainerRef = ref();
const onFocus = function () {
  showPopover.value = true;
  if (props.showAllOnFocus) selectContainerRef.value.loadSuggestions(inputValue.value, true);
};
const clear = function () {
  inputValue.value = '';
  inputValueLocked.value = false;
  showPopover.value = false;
  props.modelValue = null;
};
const inputRef = ref(null);
__expose({ inputRef });

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ari-search-bar-container", {'ari-search-bar-md': __props.medium, 'ari-search-bar-xs': __props.xs}]),
    id: containerDynamicId.value
  }, [
    createVNode(script$l, mergeProps(_ctx.$attrs, {
      input: "",
      search: "",
      placeholder: !_ctx.$attrs.label ? __props.placeholder : null,
      modelValue: inputValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = $event => ((inputValue).value = $event)),
        _cache[1] || (_cache[1] = $event => (_ctx.$refs.selectContainerRef.loadSuggestions($event)))
      ],
      ref_key: "inputRef",
      ref: inputRef,
      clearable: "",
      onBlur: _ctx.$refs.selectContainerRef?.onBlur,
      onFocus: _cache[2] || (_cache[2] = $event => (onFocus()))
    }), {
      suffix: withCtx(() => [
        createElementVNode("div", _hoisted_2$6, [
          withDirectives(createElementVNode("div", { onClick: clear }, [..._hoisted_4$4], 512 /* NEED_PATCH */), [
            [vShow, __props.modelValue]
          ]),
          createCommentVNode(" <div v-show=\"!showPopover\">\r\n            <i class=\"fa-light fa-chevron-down\"></i>\r\n          </div>\r\n          <div v-show=\"showPopover\">\r\n            <i class=\"fa-light fa-chevron-up\"></i>\r\n          </div> ")
        ])
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["placeholder", "modelValue", "onBlur"]),
    createVNode(script$8, mergeProps(_ctx.$attrs, {
      inputValue: inputValue.value,
      "onUpdate:inputValue": _cache[3] || (_cache[3] = $event => ((inputValue).value = $event)),
      isValueLocked: inputValueLocked.value,
      "onUpdate:isValueLocked": _cache[4] || (_cache[4] = $event => ((inputValueLocked).value = $event)),
      ref_key: "selectContainerRef",
      ref: selectContainerRef,
      showPopover: showPopover.value,
      "onUpdate:showPopover": _cache[5] || (_cache[5] = $event => ((showPopover).value = $event)),
      containerId: containerDynamicId.value,
      isInputInError: _ctx.$refs.inputRef?.isError,
      showAllOnFocus: __props.showAllOnFocus,
      modelValue: __props.modelValue,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (emits('update:modelValue', $event)))
    }), null, 16 /* FULL_PROPS */, ["inputValue", "isValueLocked", "showPopover", "containerId", "isInputInError", "showAllOnFocus", "modelValue"])
  ], 10 /* CLASS, PROPS */, _hoisted_1$7))
}
}

};

script$7.__file = "src/components/Ari-SearchBar/ari-search-bar.vue";

var script$6 = {
  name: 'AriInput',
  components: { AriAbsoluteError: script$m },
  mixins: [script$d],
  emits: ['change', 'input', 'update:modelValue'],
  data () {
    return {
      showPassword: false,
      isFocused: false,
      searchTimeout: null
    };
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  computed: {
    currenNativetInputType () {
      if (this.type) return this.type;
      else if (this.password && !this.showPassword) return 'password';
      else return null;
    },
    tracking () {
      if (this.change) return 'change';
      else return 'input';
    },
    inputType () {
      if (!this.label) return 'label-less';
      if (this.inputError) return 'has-error';
      else return 'default';
    },
    calculatedPreIcon () {
      if (this.search) return 'fa-search';
      else if (this.preIcon) return this.preIcon;
      else return null;
    },
    calculatedIndent () {
      return this.password || this.preIcon || this.actionIcon ? 'indent-xxs' : 'indent-sm';
    },
    actionIconComputed () {
      if (this.password) {
        if (!this.showPassword) return 'fa-eye';
        else return 'fa-eye-slash';
      } else return this.actionIcon;
    }
  },
  methods: {
    handleBlur(event) {
      this.$emit('blur', event);
      this.isFocused = false;
    },
    handleFocus(event) {
      this.$emit('focus', event);
      this.isFocused = true;
    },
    clickAction () {
      if (this.password) this.showPassword = !this.showPassword;
      else {
        this.$emit('action');
      }
    },
    focus () {
      this.$refs.myInput.focus();
    },
    handleEnterKeyPress () {
      this.$emit('onEnterKeyPressed');
    },
    emitUpdate (eventNewValue) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        const { target } = eventNewValue;
        if (target && target.value) this.$emit('update:modelValue', target.value);
        else this.$emit('update:modelValue', '');
      }, this.debounce);

    }
  },
  props: {
    /**
     * Placeholder qui vient se placer au dessus de l'input après focus / si il y'a un modelValue
    */
    label: {
      type: String
    },
    /**
     * Affiche un background d'input blanc
     */
    whiteBg: Boolean,
    /**
     * Fix la max-width de l'input à 200px
    */
    medium: Boolean,
    /**
     * Fix la max-width de l'input à 130px
    */
    small: Boolean,
    /**
     * Fix la max-width de l'input à 120px
    */
    xs: Boolean,
    /**
     * Utilise le data-theme hérité à la place du thème du club
     */
    useDataTheme: Boolean,
    search: Boolean,
    type: [String, null],
    /**
     * Valeur de l'input
    */
    modelValue: [String, Number],
    /**
     * Passe le watcher de @input à @change
     */
    change: Boolean,
    /**
     * Désactive l'input
     */
    disabled: Boolean,
    /**
     * Placeholder de l'input
     */
    placeholder: String,
    /**
     * Icon du bouton
     */
    preIcon: String,
    /**
     * Icon de l'encart d'action à droite de l'input
     */
    actionIcon: {
      type: [String, null],
      default: null
    },
    /**
     * Centre le placeholder et le contenu de l'input
     */
    center: Boolean,
    password: Boolean,
    /**
     * Arrondi les bords de l'input
     */
    rounded: Boolean,
    /**
     * Icon a afficher en fin d'input
     */
     postIcon: String,
         /**
     * Temps en ms pour le debounce
     */
    debounce: {
      type: Number,
      default: 150
    },
    textarea: Boolean
  }
};

const _hoisted_1$6 = ["type", "disabled", "value", "placeholder", "id"];

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriAbsoluteError = resolveComponent("AriAbsoluteError");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ariInput-height ari-input", {'ari-rounded-input': $props.rounded, 'white-bg': $props.whiteBg, 'ari-input-default-bg': !$props.whiteBg, 'is-disabled': $props.disabled,
       'has-error': _ctx.inputError, 'size-medium': $props.medium, 'ariInput-small': $props.small, 'ariInput-xs': $props.xs, 'ari-input-data-theme': _ctx.$attrs['data-theme'] || $props.useDataTheme }])
  }, [
    ($options.calculatedPreIcon && $options.calculatedPreIcon.length > 0)
      ? (openBlock(), createElementBlock("i", {
          key: 0,
          class: normalizeClass(['ariInput-icon fa-solid', $options.calculatedPreIcon, $props.modelValue && $props.modelValue.length > 0 ? 'ariInput-filled':''])
        }, null, 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    createElementVNode("input", mergeProps(_ctx.$attrs, {
      type: $options.currenNativetInputType,
      disabled: $props.disabled
    }, {
      [toHandlerKey($options.tracking)]: _cache[0] || (_cache[0] = $event => ($options.emitUpdate($event)))
    }, {
      onKeyup: _cache[1] || (_cache[1] = withKeys($event => ($options.handleEnterKeyPress()), ["enter"])),
      value: $props.modelValue,
      class: [$options.inputType, $options.calculatedIndent, { 'no-indent': $props.center }],
      ref: "myInput",
      onFocus: _cache[2] || (_cache[2] = $event => ($options.handleFocus($event))),
      onBlur: _cache[3] || (_cache[3] = $event => ($options.handleBlur($event))),
      placeholder: !$props.label ? $props.placeholder : null,
      id: 'ari-input_' + _ctx.uid,
      onChange: _cache[4] || (_cache[4] = $event => (_ctx.$emit('change', $event.target.value)))
    }), null, 16 /* FULL_PROPS */, _hoisted_1$6),
    ($props.postIcon)
      ? (openBlock(), createElementBlock("i", {
          key: 1,
          class: normalizeClass($props.postIcon)
        }, null, 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    ($props.label || (!$props.label && !$props.modelValue))
      ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass({'ari-label': ($props.modelValue && $props.label) || ($data.isFocused && $props.label), 'ari-placeholder-search': ((!$data.isFocused || !$props.modelValue ) && $props.search),
         'ari-center-input': ($props.center && !$data.isFocused && !$props.modelValue), 'has-error': _ctx.isError, 'ari-placeholder': !$data.isFocused || !$props.modelValue, 'ari-placeholder-with-pre-icon': $props.preIcon }),
          onClick: _cache[5] || (_cache[5] = $event => ($options.focus()))
        }, toDisplayString($props.label), 3 /* TEXT, CLASS */))
      : createCommentVNode("v-if", true),
    ($options.actionIconComputed)
      ? (openBlock(), createElementBlock("div", {
          key: 3,
          onClick: _cache[6] || (_cache[6] = $event => ($options.clickAction())),
          class: normalizeClass(["cursorMimine", { 'action-icon': ($options.actionIconComputed && !$props.password)}])
        }, [
          (($props.actionIcon && $props.actionIcon.length > 0) || $props.password)
            ? (openBlock(), createElementBlock("i", {
                key: 0,
                class: normalizeClass(["ariInput-icon cursor-pointer fas", $options.actionIconComputed])
              }, null, 2 /* CLASS */))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    withDirectives(createVNode(_component_AriAbsoluteError, {
      text: _ctx.inputError,
      uid: _ctx.uid,
      parentContainerId: 'ari-input_' + _ctx.uid
    }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
      [vShow, _ctx.isError]
    ])
  ], 2 /* CLASS */))
}

script$6.render = render$2;
script$6.__file = "src/components/Ari-Input/ari-input2.vue";

var script$5 = {
  name: 'AriDropdown',
  emits: ['blur', 'focus', 'update:modelValue'],
  components: { AriInputClassic: script$6, AriAbsoluteError: script$m, AriCoreContainer: script$c },
  mixins: [script$d],
  data () {
    return {
      isHovered: false,
      dropdownOpen: false,
      search: '',
      fixHeight: null,
      fixWidth: null
    };
  },
  props: {
    /**
     * Description / indication du dropdown
     */
    description: String,
    /**
     * Si couplé à un label, le label ne sera pas en floating sur le dropdown
     */
    noFloatingLabel: Boolean,
    /**
     * Allow multiple-selection
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Set a really small size
     */
    mini: Boolean,
    /**
     * Set a small size
     */
    small: Boolean,
    /**
     * Set a large size
     */
    medium: Boolean,
    /**
     * Label of the dropdown
     */
    label: {
      type: String
    },
    /**
     * Message displayed if not data are selected
     */
    emptyLabel: {
      type: String,
      default: function () {
        return translationService.translate('dropdown.empty');
      }
    },
    /**
     * Allow to clear selected data
     */
    clearable: {
      type: Boolean,
      default: true
    },
    /**
     * Define which data will be emited on select
     */
    valueKey: {
      type: String,
      default: 'value'
    },
    /**
     * Define what will be displayed in the dropdown
     */
    labelKey: {
      type: [String, Function],
      default: 'label'
    },
    /**
     * If set to true, the object returned will be the full object and not only the valueKey.
     */
     returnFullObject: Boolean,
    /**
     * Use the inherited data-theme
     */
    useDataTheme: Boolean,
    /**
     * Define which key will be used for the v-for (use if valueKey = false)
     */
    customKey: {
      type: String
    },
    /**
     * Minchar before starting the filtering
     */
    minChar: {
      type: [Number, null],
      default: 3
    },
    /**
     * Allow data to be sorted
     */
    filterable: {
      type: Boolean,
      default: false
    },
    /**
     * Add an option that display showAllLabel and emit showAllValue 
     */
    showAll: {
      type: Boolean,
      default: false
    },
    /**
     * Label of the showAll option
     */
    showAllLabel: {
      type: String,
      default: function () {
        return translationService.translate('dropdown.selectAll');
      }
    },
    /**
     * Value emited when showAll option is selected
     */
    showAllValue: {
      default: null
    },
    /**
     * Array of datas displayed in the dropdown
     */
    datas: {
      type: Array
    },
    /**
     * v-model
     */
    modelValue: {
    },
    /**
     * Disable le component
     */
    disabled: Boolean,
  },
  mounted () {
  },
  methods: {
    /**
     * Fonction récursive qui vérifie l'élément cliqué puis chaque parent de cet élément pour comparer son ID avec dynamicID
     * Si Les ID match a un moment, on ne close pas la fenetre car l'on est "dans" le dropdown
     * Si les ID ne matchent jamais, on a effectivement cliqué en dehors et on ferme la fenetre
     * ON est obligé de faire ceci a cause du <Teleport /> qui cassent l'architecture HTML 
     * @param {DOM} PointerEvent 
     * @param {*} fromCallback 
     */
    clickOutsideDropdownContainer (PointerEvent, fromCallback = false) {
      const searchedElement = fromCallback ? 'parentElement' : 'srcElement';
      if (this.dropdownOpen && PointerEvent && PointerEvent[searchedElement]) {
        const isBindToMyDropdown = PointerEvent[searchedElement].id === this.dynamicId;
        const isLastElement = !PointerEvent[searchedElement]['parentElement'];
        if (!isBindToMyDropdown) {
          if (isLastElement) this.closeDropdown();
          else this.clickOutsideDropdownContainer(PointerEvent[searchedElement], true);
        }
      }
    },
    closeDropdown () {
      this.dropdownOpen = false;
    },
    sanitizeText: function (value) {
      if (value && typeof value === 'string') {
        let token = 0;
        let result = '';
        for (token = 0; token < value.length; token++) {
          if (token === 0) result += value[token].toUpperCase();
          else result += value[token].toLowerCase();
        }
        return result;
      } else return value;
    },
    toggleDropDown() {
      if (!this.disabled) {
        this.dropdownOpen = !this.dropdownOpen;
        this.generatePosition();
      }
    },
    generatePosition () {
      const dropDownContainer = document.querySelector(`#${this.containerDynamicId}`);
      const dropDown = document.querySelector(`#${this.dynamicId}`);
      const containerWidth = dropDownContainer.offsetWidth;
      computePosition(dropDownContainer, dropDown,
      {
        placement: 'bottom-start',
        middleware: [flip(), shift(), offset(5)]  
      }).then(({x, y}) => {
        Object.assign(dropDown.style, {
          left: `${x}px`,
          top: `${y}px`,
          'max-width': `${containerWidth}px`,
          width: `${containerWidth}px`
        });
      });
    },
    optionCss (optionData) {
      const css = [];
      if (this.isClassicDisplay) this.useValueKey(optionData) === this.modelValue ? css.push('ari-option-selected') : css.push('ubuntuRegular');
      else {
        this.modelValue && typeof Array.isArray(this.modelValue) && this.modelValue.includes(this.useValueKey(optionData)) ? css.push('ari-option-selected') : css.push('ubuntuRegular');
      }
      if (optionData.disabled) css.push('disabled');
      return css;
    },
    useValueKey (value) {
      if (this.valueKey !== null) {
        if (this.valueKey === null) return value;
        else return value && value[this.valueKey];
      } else return value;
    },
    useCustomKey (data) {
      if (this.customKey) {
        return data[this.customKey];
      } else if (this.valueKey) {
        return this.useValueKey(data);
      } else return data;
    },
    useLabelKey (value) {
      if (this.labelKey !== null) {
        if (typeof this.labelKey === 'string') return value && value[this.labelKey];
        else {
          return this.labelKey(value);
        }
      } else return value;
    },
    clickOption (value, disabled = false) {
      if (!disabled) {
        if (this.multiple) {
          let result = this.modelValue || [];
          if (value === null) {
            result = null;
          } else if (result.includes(value)) {
            result = result.filter(function (item) {
              return item !== value;
            });
            if (typeof result === 'object' && result.length === 0) result = null;
          } else result.push(value);
          this.$emit('update:modelValue', result);
          if (this.filterable) this.dropdownOpen = false;
        } else {
          if (this.clearable && value === this.modelValue) this.$emit('update:modelValue', null);
          else this.$emit('update:modelValue', value);
          this.dropdownOpen = false;
        }
        this.search = '';
      }
    },
  },
  watch: {
    dropdownOpen (val) {
      if (val && this.filterable) {
        this.$nextTick(() => {
          if (this.$refs[`ari-select-input-search_${this.uid}`]) this.$refs[`ari-select-input-search_${this.uid}`].focus();
          const myContainer = document.getElementById(this.dynamicId); 
          if (myContainer) {
            this.fixHeight = myContainer.offsetHeight;
            this.fixWidth = myContainer.offsetWidth;
          }
        });
      } else {
        this.fixHeight = null;
        this.fixWidth = null;
        this.search = '';
      }
    }
  },
  computed: {
    size () {
      if (this.mini) return 'ari-dropdown-mini';
      else if (this.small) return 'ari-dropdown-small';
      else if (this.medium) return 'ari-dropdown-medium';
      else return 'ari-dropdown-large';
    },
    dynamicId () {
      return `ari-dropdown_${this.uid}`;
    },
    containerDynamicId () {
      return `ari-dropdown-container_${this.uid}`;
    },
    isClassicDisplay () {
      return !this.multiple || (this.multiple && !this.modelValue);
    },
    cancelMode () {
      let cancelMode = false;
      if (this.displayShowAll && this.showAllValue === this.modelValue) cancelMode = false;
      else if (this.isHovered && this.displayedData) cancelMode = true;
      return cancelMode;
    },
    displayedOptions () {
      if (this.search) {
        return this.datas.filter(data => this.useLabelKey(data).toLowerCase().includes(this.search.toLowerCase())) || [];
      } else {
        return this.datas || [];
      }
    },
    displayedData () {
      if ((this.modelValue && this.datas) || this.modelValue === 0 || this.modelValue === false) {
        if (!Array.isArray(this.modelValue) || (Array.isArray(this.modelValue) && this.modelValue.length < 2)) {
          let idDisplayedData = Array.isArray(this.modelValue) ? this.modelValue[0] : this.modelValue;
          if (typeof idDisplayedData === 'object' && idDisplayedData !== null) idDisplayedData = this.useCustomKey(idDisplayedData);
          const result = this.datas.find(element => this.useCustomKey(element) === idDisplayedData);
          return result ? this.useLabelKey(result) : false;
        } else {
          return this.modelValue.length + ' éléments sélectionnés';
        }
      } else if (this.modelValue === null && this.displayShowAll && this.showAllValue === null) {
        return this.showAllLabel;
      } else return false;
    },
    displayShowAll () {
      return this.showAll && (this.datas?.length > 1 || this.datas?.length === 1  && this.showAll);
    }
  }
};

const _hoisted_1$5 = { class: "ari-select__container" };
const _hoisted_2$5 = { class: "ari-select__labelAndDescr" };
const _hoisted_3$5 = {
  key: 0,
  class: "ari-select_label-no-floating"
};
const _hoisted_4$3 = {
  key: 1,
  class: "ari-select_description"
};
const _hoisted_5$2 = ["id"];
const _hoisted_6$1 = ["title"];
const _hoisted_7$1 = {
  key: 1,
  class: "container-show-data"
};
const _hoisted_8$1 = ["id"];
const _hoisted_9$1 = ["onClick"];
const _hoisted_10$1 = {
  key: 0,
  class: "ari-dropdown-checkbox-container"
};
const _hoisted_11$1 = ["checked"];
const _hoisted_12 = {
  key: 2,
  class: "ari-dropdown_no-options"
};

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriInputClassic = resolveComponent("AriInputClassic");
  const _component_AriAbsoluteError = resolveComponent("AriAbsoluteError");
  const _directive_click_outside = resolveDirective("click-outside");

  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$5, [
      createElementVNode("div", _hoisted_2$5, [
        ($props.label && $props.noFloatingLabel)
          ? (openBlock(), createElementBlock("span", _hoisted_3$5, toDisplayString($props.label), 1 /* TEXT */))
          : createCommentVNode("v-if", true),
        ($props.description && $props.noFloatingLabel)
          ? (openBlock(), createElementBlock("span", _hoisted_4$3, toDisplayString($props.description), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      withDirectives((openBlock(), createElementBlock("div", {
        onClick: _cache[4] || (_cache[4] = $event => ($options.toggleDropDown())),
        class: normalizeClass([[$options.size, { 'data-theme': $props.useDataTheme || _ctx.$attrs['data-theme'], 'ari-select-with-label': $props.label, 'ari-select-disabled': $props.disabled, 'ari-select-error': _ctx.isError && !$props.disabled }], "ari-select-container"]),
        id: $options.containerDynamicId
      }, [
        ($props.label && !$props.noFloatingLabel)
          ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(["ari-select-floating-label", { open: $data.dropdownOpen, 'ari-dropdown-with-selected-data': !!$options.displayedData }])
            }, toDisplayString($props.label), 3 /* TEXT, CLASS */))
          : createCommentVNode("v-if", true),
        createElementVNode("div", {
          class: normalizeClass(["ari-select", { open: $data.dropdownOpen }])
        }, [
          createElementVNode("span", {
            class: normalizeClass(["ari-div-selected-data text-one-line", { 'ari-dropdown-data-selected': $options.displayedData && $options.displayedData !== $props.showAllLabel }]),
            onMouseenter: _cache[2] || (_cache[2] = $event => ($data.isHovered = true)),
            onMouseleave: _cache[3] || (_cache[3] = $event => ($data.isHovered = false)),
            title: $options.displayedData || ''
          }, [
            createElementVNode("div", {
              class: normalizeClass(["ari-label-selected-data", { delete: $options.cancelMode }])
            }, [
              ($props.filterable && $data.dropdownOpen)
                ? (openBlock(), createBlock(_component_AriInputClassic, {
                    key: 0,
                    autofocus: "",
                    ref: 'ari-select-input-search_' + _ctx.uid,
                    minChar: $props.minChar,
                    modelValue: $data.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.search) = $event)),
                    postIcon: "fa fa-search",
                    input: "",
                    class: "dropdown-search"
                  }, null, 8 /* PROPS */, ["minChar", "modelValue"]))
                : (openBlock(), createElementBlock("div", _hoisted_7$1, [
                    renderSlot(_ctx.$slots, "prefix"),
                    createElementVNode("span", null, toDisplayString($options.displayedData || $props.emptyLabel), 1 /* TEXT */)
                  ]))
            ], 2 /* CLASS */),
            ($options.cancelMode && $props.clearable && $props.datas && ($props.datas.length > 1 || $props.datas.length === 1  && $props.showAll) && !$props.disabled)
              ? (openBlock(), createElementBlock("i", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = withModifiers($event => (_ctx.$emit('update:modelValue', null)), ["stop"])),
                  class: "ari-dropdown-icon color-black fa fa-times"
                }))
              : ($props.datas && ($props.datas.length > 1 || ($props.datas.length === 1  && $props.showAll)))
                ? (openBlock(), createElementBlock("i", {
                    key: 1,
                    class: normalizeClass(["ari-dropdown-icon color-black fa", 'fa-chevron-' + ($data.dropdownOpen ? 'up' : 'down') ])
                  }, null, 2 /* CLASS */))
                : createCommentVNode("v-if", true)
          ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_6$1)
        ], 2 /* CLASS */),
        withDirectives(createVNode(_component_AriAbsoluteError, {
          text: _ctx.inputError,
          uid: _ctx.uid,
          parentContainerId: $options.containerDynamicId
        }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
          [vShow, _ctx.isError]
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_5$2)), [
        [_directive_click_outside, $options.clickOutsideDropdownContainer]
      ])
    ]),
    (openBlock(), createBlock(Teleport, { to: "body" }, [
      withDirectives(createElementVNode("div", {
        id: $options.dynamicId,
        class: normalizeClass(["ari-option-wrapper", [$options.size +'-wrapper', { 'data-theme': $props.useDataTheme || _ctx.$attrs['data-theme'] }]]),
        "data-theme": "main",
        style: normalizeStyle($data.fixHeight && $data.fixWidth ? `height: ${$data.fixHeight}px; width: ${$data.fixWidth}px;` : null)
      }, [
        ($options.displayShowAll)
          ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(["ari-option text-one-line", ($props.datas && $options.useValueKey($props.datas) === $props.modelValue ? 'ari-option-selected' :  ' ubuntuRegular')]),
              onClick: _cache[5] || (_cache[5] = $event => ($options.clickOption($props.showAllValue)))
            }, toDisplayString($props.showAllLabel), 3 /* TEXT, CLASS */))
          : createCommentVNode("v-if", true),
        ($options.displayedOptions.length)
          ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList($options.displayedOptions, (data) => {
              return (openBlock(), createElementBlock("div", {
                key: $options.useCustomKey(data),
                onClick: $event => ($options.clickOption($options.useValueKey(data), data.disabled)),
                class: normalizeClass(["ari-option text-one-line", $options.optionCss(data)])
              }, [
                ($props.multiple)
                  ? (openBlock(), createElementBlock("div", _hoisted_10$1, [
                      createElementVNode("input", {
                        type: "checkbox",
                        checked: $props.modelValue && typeof $props.modelValue === 'object' && $props.modelValue.includes($options.useValueKey(data))
                      }, null, 8 /* PROPS */, _hoisted_11$1)
                    ]))
                  : createCommentVNode("v-if", true),
                renderSlot(_ctx.$slots, "prefix_option", { data: data }),
                createElementVNode("span", null, toDisplayString($options.sanitizeText($options.useLabelKey(data))), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_9$1))
            }), 128 /* KEYED_FRAGMENT */))
          : (openBlock(), createElementBlock("span", _hoisted_12, "Aucune donnée"))
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_8$1), [
        [vShow, $data.dropdownOpen]
      ])
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}

script$5.render = render$1;
script$5.__file = "src/components/Ari-Dropdown/ari-dropdown.vue";

const __default__$3 = {
  name: 'AriCheckbox',
  components: { AriAbsoluteError: script$m },
  mixins: [script$d],
  data () {
    return {
      isClicking: false,
      uid: generateUID()
    }
  },
  methods: {
  },
  computed: {},
  props: {
    modelValue: Boolean,
    /** Disabled la checkbox */
    disabled: Boolean,
    /** Phrase affichée à droite de la checkbox */
    label: String,
    /**
     * Utilise le data-theme parent
     */
    useDataTheme: Boolean,
    leftLabel: Boolean,
    indeterminate: Boolean,
    labelSize: {
      type: String,
      default: '13'
    }
  },
  watch: {
    indeterminate (newValue) {
      const myCheckbox = document.getElementById(this.uid);
      if (newValue) {
        myCheckbox.indeterminate = true;
      } else myCheckbox.indeterminate = false;
    }
  }
};
const __injectCSSVars__ = () => {
useCssVars(_ctx => ({
  "0338e10f-\`\$\{labelSize\}px\`": (`${_ctx.labelSize}px`)
}));};
const __setup__ = __default__$3.setup;
__default__$3.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__;

const _hoisted_1$4 = ["id"];
const _hoisted_2$4 = ["for"];
const _hoisted_3$4 = ["id", "checked", "disabled"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AriAbsoluteError = resolveComponent("AriAbsoluteError");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ari-checkbox", { 'ari-checkbox-disabled': $props.disabled, 'ari-checkbox-data-theme': $props.useDataTheme || _ctx.$attrs['data-theme'],
       'ari-checkbox-selected': $props.modelValue, 'ari-checkbox__right': !$props.leftLabel}]),
    id: 'ari-checkbox_' + $data.uid
  }, [
    createElementVNode("label", {
      for: $data.uid,
      class: "ari-checkbox-label",
      onMousedown: _cache[0] || (_cache[0] = $event => ($data.isClicking= true)),
      onMouseup: _cache[1] || (_cache[1] = $event => ($data.isClicking= false)),
      onMouseleave: _cache[2] || (_cache[2] = $event => ($data.isClicking= false))
    }, [
      createTextVNode(toDisplayString($props.label) + " ", 1 /* TEXT */),
      (!$props.label)
        ? renderSlot(_ctx.$slots, "default", { key: 0 })
        : createCommentVNode("v-if", true)
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_2$4),
    createElementVNode("div", {
      class: normalizeClass([{ 'ari-radio-checkbox__clicked': $data.isClicking && !$props.disabled }, "ari-checkbox__input"])
    }, [
      createElementVNode("input", {
        id: $data.uid,
        type: "checkbox",
        checked: $props.modelValue,
        onMousedown: _cache[3] || (_cache[3] = $event => ($data.isClicking= true)),
        onMouseup: _cache[4] || (_cache[4] = $event => ($data.isClicking= false)),
        onMouseleave: _cache[5] || (_cache[5] = $event => ($data.isClicking= false)),
        disabled: $props.disabled,
        onChange: _cache[6] || (_cache[6] = $event => (_ctx.$emit('update:modelValue', !$props.modelValue))),
        class: normalizeClass({ 'ari-checkbox__indeterminate': $props.indeterminate })
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3$4)
    ], 2 /* CLASS */),
    withDirectives(createVNode(_component_AriAbsoluteError, {
      text: _ctx.inputError,
      uid: $data.uid,
      parentContainerId: 'ari-checkbox_' + $data.uid,
      top: "20"
    }, null, 8 /* PROPS */, ["text", "uid", "parentContainerId"]), [
      [vShow, _ctx.isError]
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1$4))
}

__default__$3.render = render;
__default__$3.__file = "src/components/Ari-Checkbox/ari-checkbox.vue";

const _hoisted_1$3 = { class: "ari-container-wrapper" };
const _hoisted_2$3 = ["id"];
const _hoisted_3$3 = ["id", "onClick"];
const _hoisted_4$2 = {
  key: 1,
  class: "ari-tab-label"
};
  const __default__$2 = { name: 'AriTabs' };

var script$4 = /*#__PURE__*/Object.assign(__default__$2, {
  props: {
    tabs: { type: Array, required: true },
    upperLine: Boolean,
    column: Boolean,
    modelValue: [String, Number, Boolean],
    labelKey: {
      type: String,
      default: 'label'
    },
    iconKey: {
      type: String,
      default: 'icon'
    },
    idKey: {
      type: String,
      default: 'id'
    },
    css: String,
    useSlot: {
      type: Boolean,
    },
    tabsGap: {
      type: Number || String,
      default: 16
    },
    scrollValue: {
      type: Number,
      default: 100
    },
    offset: {
      type: Number || String,
      default: 7
    }
  },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

  const emit = __emit;
  const uid = generateUID();
  const props = __props;
  const useIconKey = function (tab) {
    if (!props.iconKey) return null;
    else return tools.useKey(tab, props.iconKey);
  };
  const offsetType = computed(() => {
    return props.upperLine ? 'top' : 'bottom';
  });
  const isTabString = function (tab) {
    return typeof tab === 'string';
  };
  const generateDomID = function (tabId) {
    if (typeof tabId === 'string') tabId = tabId.replace(' ', ''); 
    return `ari-tab-${uid}_${tabId}`
  };
  const showScrollButtons = ref(false);
  const checkScrollButtons = function () {
    showScrollButtons.value = tools.isOverflown(document.getElementById(`ari-tab-${uid}`)) && props.tabs?.length;

  };
  onMounted(() => {
    setTimeout(() => {
      checkScrollButtons();
      // Obligé de setTimeout car si icon il y'a, elle arrive après nextTick
      if (!props.modelValue && props.tabs.length) {
        const key = typeof props.tabs[0] === 'string' ? props.tabs[0] : props.tabs[0][props.idKey];  
        emit('update:modelValue', key);
      }
      resizeListener.value.subscribe({ id: uid, fx: checkScrollButtons });
      document.getElementById(`ari-tab-${uid}`).addEventListener('scroll', handleShiftScroll);
      if (props.modelValue) calculateTabPosition(props.modelValue);
    }, 500);
  });

  // HANDLE SCROLL & TAB POSITION
  const disabledScroll = ref('left');
  const scrollToNextItem = function (value) {
    disabledScroll.value = false;
    const tabContainer = document.getElementById(`ari-tab-${uid}`);
    const currentScroll = tabContainer.scrollLeft;
    const scrollValue = value > 0 ? currentScroll + props.scrollValue : currentScroll - props.scrollValue;
    tabContainer.scroll({ left: scrollValue, top: 0, behavior: 'smooth' });
    if (scrollValue <= 0) disabledScroll.value = 'left';
    else if ((currentScroll + props.scrollValue + tabContainer.clientWidth) > tabContainer.scrollWidth && value > 0) disabledScroll.value = 'right';
  };
  const leftValueUnderline = ref(0);
  const tabWidth = ref(62);
  const calculateTabPosition = function (tabId) {
    const myTab = document.getElementById(generateDomID(tabId));
    const tabIndex = props.tabs.findIndex(tab => tab.id === tabId);
    if (myTab) {
      myTab.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
      leftValueUnderline.value = myTab.offsetLeft;
      tabWidth.value = myTab.offsetWidth;
    }
    if (tabIndex === 0) disabledScroll.value = 'left';
    else if (tabIndex === props.tabs.length - 1) disabledScroll.value = 'right';
    else disabledScroll.value = null;
  };

  const onClickTab =  function (tabId) {
    emit('update:modelValue', tabId);
  };
  const atleastOneIcon = computed(() => {
    return props.tabs.some(tab => tools.useKey(tab, props.idKey));
  });

  const getTabId = function(tab) {
    if (tab[props.idKey] !== undefined) return tab[props.idKey]
    else return tab
  };
  const handleShiftScroll = function (event) {
    const scrollLeft = document.getElementById(`ari-tab-${uid}`).scrollLeft;
    if (scrollLeft === 0) disabledScroll.value = 'left';
    else if (Math.ceil(scrollLeft) + event.srcElement.clientWidth === event.srcElement.scrollWidth) disabledScroll.value = 'right';
    else disabledScroll.value = null;
  };
  // WATCH
  const resizeListener = ref(new Resize()); // On le met dans data pour pouvoir facilement unsubscribe au destroy
  watch(() => props.modelValue, (newValue) => {
    calculateTabPosition(newValue);
  });
  onUnmounted(() => {
    resizeListener.value.unsubscribe(uid);
    if (document.getElementById(`ari-tab-${uid}`)) {
      document.getElementById(`ari-tab-${uid}`).removeEventListener('scroll', handleShiftScroll);
    }
  });


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$3, [
    (showScrollButtons.value)
      ? (openBlock(), createElementBlock("i", {
          key: 0,
          class: normalizeClass(["ari-tabs-scroll ari-tabs-button-right-scroll fa fa-chevron-right", { 'ari-tabs-scroll-disabled': disabledScroll.value === 'right'}]),
          onClick: _cache[0] || (_cache[0] = $event => (scrollToNextItem(1)))
        }, null, 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    (showScrollButtons.value)
      ? (openBlock(), createElementBlock("i", {
          key: 1,
          class: normalizeClass(["ari-tabs-scroll ari-tabs-button-left-scroll fa fa-chevron-left", { 'ari-tabs-scroll-disabled': disabledScroll.value === 'left'}]),
          onClick: _cache[1] || (_cache[1] = $event => (scrollToNextItem(-1)))
        }, null, 2 /* CLASS */))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      class: "ari-tabs-container",
      style: normalizeStyle(`padding-${offsetType.value}: ${__props.offset}px; gap: ${__props.tabsGap}px;`),
      id: `ari-tab-${unref(uid)}`
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(__props.tabs, (tab) => {
        return (openBlock(), createElementBlock("div", {
          class: normalizeClass(["ari-tabs-items", [__props.css, { 'ari-tabs-not-slot': !__props.useSlot, 'ari-tabs-column': __props.column, 'ari-tabs-upper-line': __props.upperLine,
                    'ari-tabs-selected': (__props.modelValue === tab || __props.modelValue === tab[__props.idKey]), 'ari-tabs_text-end': atleastOneIcon.value }]]),
          id: generateDomID(getTabId(tab)),
          onClick: $event => (onClickTab(getTabId(tab)))
        }, [
          (__props.useSlot)
            ? renderSlot(_ctx.$slots, "default", {
                key: 0,
                datas: tab
              })
            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                (useIconKey(tab))
                  ? (openBlock(), createElementBlock("i", {
                      key: 0,
                      class: normalizeClass([useIconKey(tab), "ari-tab-icon"])
                    }, null, 2 /* CLASS */))
                  : createCommentVNode("v-if", true),
                (tab[__props.labelKey] || isTabString(tab))
                  ? (openBlock(), createElementBlock("span", _hoisted_4$2, toDisplayString(tab[__props.labelKey] || tab), 1 /* TEXT */))
                  : createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ], 10 /* CLASS, PROPS */, _hoisted_3$3))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (__props.modelValue !== undefined && __props.tabs.length)
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            style: normalizeStyle(`${offsetType.value}: 0px; transform: translateX(${leftValueUnderline.value}px);width: ${tabWidth.value}px;`),
            class: "ari-tab-underline"
          }, null, 4 /* STYLE */))
        : createCommentVNode("v-if", true)
    ], 12 /* STYLE, PROPS */, _hoisted_2$3)
  ]))
}
}

});

script$4.__file = "src/components/Ari-Tabs/ari-tabs.vue";

const _hoisted_1$2 = ["id"];
const _hoisted_2$2 = { class: "ari-toast-titles" };
const _hoisted_3$2 = { class: "ari-toast-title" };
const _hoisted_4$1 = { class: "ari-toast-subtitle" };
const _hoisted_5$1 = { class: "ari-toast-actions-container" };

var script$3 = {
  __name: 'ari-toast',
  props: {
  uid: { type: String },
  mainTitle: { type: String  },
  autoClose: { type: Boolean, default: true, required: false },
  duration: { type: Number, default: 2, required: false },
  subTitle: { type: String },
  clearable: { type: Boolean, default: true },
  show: { type: Boolean, default: true },
  icon: String,
  valid: Boolean,
  pending: Boolean,
  error: Boolean,
  attention: Boolean,
  action: String,
  actionIsText: Boolean,
},
  emits: ['close', 'clickAction'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// TOAST POSITION AND CLOSING
const timer = ref(-1);
const startedAt = ref(0);
const delay = ref(0);
onMounted(() => {
  if (props.autoClose) {
    startedAt.value = Date.now();
    delay.value = props.duration * 1000;
    timer.value = setTimeout(close, delay.value);
  }
});

const close = () => {
  emit("close");
};
const passAccentToButton = computed(() => {
  if (props.valid) return { valid: true };
  else if (props.pending) return { pending: true };
  else if (props.error) return { error: true };
  else return { attention: true }
});
// TOAST DESIGN
const getAccentIcon = function () {
    if (props.icon) return props.icon;
    else if (props.valid) return 'fa-circle-check';
    else if (props.error) return 'fa-triangle-exclamation';
    else if (props.attention) return 'fa-circle-exclamation';
    else return 'fa-circle-info'
  };
const getAccentClass = function () {
  if (props.valid) return 'ari-toast-container-valid';
  else if (props.pending) return 'ari-toast-container-pending';
  else if (props.error) return 'ari-toast-container-error';
  else return 'ari-toast-container-attention';
};


return (_ctx, _cache) => {
  return withDirectives((openBlock(), createElementBlock("div", {
    id: __props.uid,
    class: normalizeClass(["ari-toast-container", [getAccentClass()]]),
    style: normalizeStyle(`--toast-duration: ${__props.duration}s;`),
    onClick: withModifiers(close, ["prevent"])
  }, [
    createElementVNode("i", {
      class: normalizeClass(["fa ari-toast-icon", getAccentIcon()])
    }, null, 2 /* CLASS */),
    createElementVNode("div", _hoisted_2$2, [
      createElementVNode("span", _hoisted_3$2, toDisplayString(__props.mainTitle), 1 /* TEXT */),
      createElementVNode("span", _hoisted_4$1, [
        (__props.subTitle)
          ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(__props.subTitle), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : renderSlot(_ctx.$slots, "subTitle", { key: 1 })
      ]),
      renderSlot(_ctx.$slots, "default")
    ]),
    createElementVNode("div", _hoisted_5$1, [
      (__props.action)
        ? (openBlock(), createBlock(script$o, mergeProps({ key: 0 }, passAccentToButton.value, {
            small: "",
            rounded: "",
            content: __props.action,
            text: __props.actionIsText,
            filled: !__props.actionIsText,
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('clickAction')))
          }), null, 16 /* FULL_PROPS */, ["content", "text", "filled"]))
        : createCommentVNode("v-if", true),
      (__props.clearable)
        ? (openBlock(), createElementBlock("i", {
            key: 1,
            class: "fa fa-circle-xmark text-on-primary h-default w-default",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:show', false)))
          }))
        : createCommentVNode("v-if", true)
    ])
  ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1$2)), [
    [vShow, __props.show]
  ])
}
}

};

script$3.__file = "src/components/Ari-Toast/ari-toast.vue";

const notifications = ref([]);
const destroyArray = ref([]);
const isMobile = function () {
  return window.innerWidth < 640;
};
const getNotifContainerId = function (container, containerOpt = {}) {
  if (isMobile()) return 'container_mobile';
  else return `${container}_${containerOpt.left ? 'left' : (containerOpt.center ? 'center' : 'right')}`;
};
function useAriToast() {
  // Reactive array of notifications.
  const renderComponent = function({ el, component, props, appContext }) {
    if (!el) el = document.getElementById('app');
    let app = createApp(component, props);
    Object.assign(app._context, appContext);
    const divContainer = document.createElement("div");
    el.appendChild(divContainer);
    app.mount(divContainer);
  
    return () => {
      // destroy app/component
      app?.unmount();
      app = undefined;
      divContainer.remove();
    }
  };
  // function to create notification
  const createNotification = (options, container = 'app', containerOpt) => {
    const containerId = getNotifContainerId(container, containerOpt);
    if (!destroyArray.value.find(objContainer => objContainer.containerId === containerId)) {
      let appContext = null;
      appContext = getCurrentInstance()?.appContext;
      destroyArray.value.push({
        callback: renderComponent({ 
          component: script$2,
          appContext,
          el: !isMobile() ? document.getElementById(container) : document.getElementById('app'),
          props: {
            ...containerOpt,
            containerId
          }
        }),
        containerId
      });
    }    const uid = `uid-toast_${generateUID()}`;
    notifications.value.unshift(
      ...[
        {
          uid,
          containerId,
          ...options,
        },
      ]
    );
  };

  // function to remove notification
  const removeNotifications = (uid) => {
    const index = notifications.value.findIndex((item) => item.uid === uid);
    let deletedNotifContainerId = null;
    if (index !== -1) deletedNotifContainerId = notifications.value.splice(index, 1)[0].containerId;
    if (!notifications.value.find(notif => notif.containerId === deletedNotifContainerId)) {
      try {
        const containerToDeleteIndex = destroyArray.value.findIndex(toastContainer => toastContainer.containerId === deletedNotifContainerId);
        destroyArray.value[containerToDeleteIndex].callback();
        destroyArray.value.splice(containerToDeleteIndex, 1);
      } catch (e) {
        console.warning('AN ERROR OCCURED DURING THE CLEANING OF TOASt CONTAINER -> ' + deletedNotifContainerId);
      }
    }
  };
  const unmountAll = () => {
    destroyArray.value = [];
  };
  onBeforeUnmount(() => {
    unmountAll();
  });
  // The two functions below are more for body
  // overflow when creating notifications that slide
  // in from outside the viewport. We will not be
  // using them for now but good to have.
  const stopBodyOverflow = () => {
    document && document.body.classList.add(...["hide-overflow"]);
  };

  const allowBodyOverflow = () => {
    document && document.body.classList.remove(...["hide-overflow"]);
  };

  // You need this to ensure we can use the
  // composition function.
  return {
    notifications,
    createNotification,
    removeNotifications,
    stopBodyOverflow,
    allowBodyOverflow,
    unmountAll
  };
}

var script$2 = {
  __name: 'ari_toast_container',
  props: {
  left: Boolean,
  center: Boolean,
  containerId: String
},
  setup(__props) {

const {
  notifications,
  removeNotifications,
  stopBodyOverflow,
  allowBodyOverflow,
} = useAriToast();
const notifWithThisContainerId = computed(() => {
  return notifications.value.filter(notif => notif.containerId === props.containerId)
});
const getNotifPlacement = computed(() => {
  if (props.center || window.innerWidth < 640) return 'toast-notifications_center';
  else if (props.left) return 'toast-notifications_left';
  else return 'toast-notifications_right';
});
const props = __props;

return (_ctx, _cache) => {
  return (openBlock(), createBlock(TransitionGroup, {
    name: "toast-notification",
    tag: "div",
    class: normalizeClass(["toast-notifications", [getNotifPlacement.value]]),
    onBeforeEnter: unref(stopBodyOverflow),
    onAfterEnter: unref(allowBodyOverflow),
    onBeforeLeave: unref(stopBodyOverflow),
    onAfterLeave: unref(allowBodyOverflow)
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(notifWithThisContainerId.value, (item) => {
        return (openBlock(), createBlock(script$3, mergeProps({
          class: { 'toast-left': __props.left, 'toast-center': __props.center, 'toast-right': !__props.left & !__props.center },
          ref_for: true
        }, item, {
          key: item.uid,
          onClose: () => { unref(removeNotifications)(item.uid); }
        }), null, 16 /* FULL_PROPS */, ["class", "onClose"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"]))
}
}

};

script$2.__file = "src/components/Ari-Toast/ari_toast_container.vue";

const _hoisted_1$1 = ["id"];
const _hoisted_2$1 = ["onClick"];
const _hoisted_3$1 = { key: 1 };
   const __default__$1 = { name: 'AriChoice' };

var script$1 = /*#__PURE__*/Object.assign(__default__$1, {
  props: {
    choices: { type: Array, required: true },
    modelValue: [String, Number],
    rounded: Boolean,
    labelKey: {
      type: String,
      default: 'label'
    },
    idKey: {
      type: String,
      default: 'id'
    },
    disabled: Boolean
  },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

  const uid = generateUID();
  const emit = __emit;
  const props = __props;
  const useKey = function (choice) {
    if (typeof choice === 'string') return choice;
    else return tools.useKey(choice, props.idKey);
  };
  const useLabel = function (choice) {
    if (typeof choice === 'string') return choice;
    else return tools.useKey(choice, props.labelKey);
  };
  const onClick = function (choice) {
    if (!choice.disabled) {
      emit('update:modelValue', useKey(choice));
    }
  };

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["ari-choice-container", { disabled: __props.disabled, 'ari-choice-container-rounded': __props.rounded }]),
    id: 'ari-choice_' + unref(uid)
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(__props.choices, (choice) => {
      return (openBlock(), createElementBlock("div", {
        class: normalizeClass(["ari-choice-option", { 'ari-choice-disabled': choice.disabled, 'ari-choice-option-selected': __props.modelValue === useKey(choice) }]),
        onClick: $event => (onClick(choice))
      }, [
        (choice.icon)
          ? (openBlock(), createElementBlock("i", {
              key: 0,
              class: normalizeClass(["fa", choice.icon])
            }, null, 2 /* CLASS */))
          : createCommentVNode("v-if", true),
        (useLabel(choice))
          ? (openBlock(), createElementBlock("span", _hoisted_3$1, toDisplayString(useLabel(choice)), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_2$1))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 10 /* CLASS, PROPS */, _hoisted_1$1))
}
}

});

script$1.__file = "src/components/Ari-Choice/ari-choice.vue";

const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
  key: 1,
  class: "rich-tooltip"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "rich-tooltip-texts" };
const _hoisted_5 = { class: "rich-tooltip-header" };
const _hoisted_6 = {
  key: 0,
  class: "rich-tooltip-title"
};
const _hoisted_7 = { class: "rich-tooltip-content" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = {
  key: 1,
  class: "rich-tooltip-footer"
};
const _hoisted_10 = { class: "rich-tooltip-action" };
const _hoisted_11 = { class: "rich-tooltip-action" };
 const __default__ = { name: 'AriTooltip' };

var script = /*#__PURE__*/Object.assign(__default__, {
  props: {
  rich: {
    type: Boolean,
    default() {
      return false;
    }
  },
  persistent: {
    type: Boolean,
    default() {
      return false;
    }
  },
  parentRef: {
    type: HTMLElement
  },
  noParent: {
    type: Boolean,
    default() {
      return false;
    }
  },
  bottomPosition: {
    type: String
  },
  leftPosition: {
    type: String
  },
  side: {
    type: String,
    validator(value) {
      return ['right','left'].includes(value);
    }
  },
  visualAsset: {
    type: String
  },
  title : {
    type: String
  },
  content: {
    type: String,
    required: true,
  },
  hasActions: {
    type: Boolean
  },
  hasSecondaryAction: {
    type: Boolean
  },
  rounded: {
    type: Boolean,
  }
},
  setup(__props) {

useCssVars(_ctx => ({
  "73684ded-css_variable": (css_variable)
}));

let parent = null;
const showTooltip = ref(false);
const props = __props;
const initialPosition = computed(() => {
  let position;
  if (props.rich && props.noParent) position = `bottom:${props.bottomPosition}px; left:${props.leftPosition}px`;
  if (props.persistent && !props.noParent) {
    parent = {
      element: props.parentRef,
      Y: props.parentRef.offsetTop,
      X: props.parentRef.offsetLeft,
      height: props.parentRef.offsetHeight,
      width: props.parentRef.offsetWidth
    };
  }
  return position;
});
onBeforeUpdate(() => {
  if (!props.noParent) {
    parent = {
      element: props.parentRef,
      Y: props.parentRef.offsetTop,
      X: props.parentRef.offsetLeft,
      height: props.parentRef.offsetHeight,
      width: props.parentRef.offsetWidth
    };
  }
});
onUpdated(() => {
  if (!props.persistent) {
    parent.element.addEventListener("mouseover", () => {
      showTooltip.value = true;
    });
    parent.element.addEventListener("mouseleave", () => {
      showTooltip.value = false;
    });
  } else if (props.persistent || props.noParent) {
    showTooltip.value = true;
  }
});
watch(showTooltip, (newValue) => {
  if (newValue == false) {
    parent.element.removeEventListener("mouseover", showTooltip);
    parent.element.removeEventListener("mouseleave", showTooltip);
  }
});
const uid = generateUID();
const css_variable = `var(--translate_${uid})`;
const uid_tooltip = `--translate_${uid}`;
function tooltipPosition(el) {
  if (!props.noParent) {
    const scrollY = window.scrollY;
    const tooltipHeight = el.offsetHeight;
    const tooltipWidth = el.offsetWidth;
    const leftFree = parent.X > tooltipWidth;
    const rightFree = parent.X + parent.width < window.innerWidth - tooltipWidth;
    const topFree = parent.Y > 0 && (scrollY + tooltipHeight) < parent.Y;
    const horizontallyCentered = parent.Y + parent.height/2 - tooltipHeight/2 + 'px';
    const verticallyCentered = parent.X + parent.width/2 - tooltipWidth/2 + 'px';
    const leftAligned = parent.X - tooltipWidth + 'px';
    const rightAligned = parent.X + parent.width + 'px';
    const topAligned = parent.Y - tooltipHeight + "px";
    const bottomAligned = scrollY + (parent.Y - scrollY) + parent.height + "px";
    if (topFree) {
      el.style.left = verticallyCentered;
      el.style.top = topAligned;
      document.documentElement.style.setProperty(uid_tooltip, 'translateY(-10px)');
    } else {
      el.style.top = bottomAligned;
      el.style.left = verticallyCentered;
      document.documentElement.style.setProperty(uid_tooltip, 'translateY(10px)');
    }
    if (props.side === 'left') {
      if (leftFree) {
        el.style.left = leftAligned;
        el.style.top = horizontallyCentered;
        document.documentElement.style.setProperty(uid_tooltip, 'translateX(10px)');
      } else if (!leftFree && rightFree) {
        el.style.left = rightAligned;
        el.style.top = horizontallyCentered;
        document.documentElement.style.setProperty(uid_tooltip, 'translateX(-10px)');
      } else if ((!rightFree && !leftFree) && !topFree) {
        el.style.left = verticallyCentered;
        el.style.top = topFree ? topAligned : bottomAligned;
        document.documentElement.style.setProperty(uid_tooltip, 'translateY(-10px)');
      }
    } else if (props.side === 'right') {
      if (rightFree) {
        if (parent.X > 0) el.style.left = rightAligned;
        else el.style.left = parent.width + 'px';
        el.style.top = horizontallyCentered;
        document.documentElement.style.setProperty(uid_tooltip, 'translateX(-10px)');
      } else if (!rightFree && leftFree) {
        el.style.left = leftAligned;
        el.style.top = horizontallyCentered;
        document.documentElement.style.setProperty(uid_tooltip, 'translateX(10px)');
      } else if ((!rightFree && !leftFree) && !topFree) {
        el.style.left = verticallyCentered;
        el.style.top = topFree ? topAligned : bottomAligned;
        document.documentElement.style.setProperty(uid_tooltip, 'translateY(-10px)');
      }
    }
  }
}
return (_ctx, _cache) => {
  return (openBlock(), createBlock(Transition, { onEnter: tooltipPosition }, {
    default: withCtx(() => [
      (showTooltip.value || (__props.noParent && __props.persistent))
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass( {'tooltip-box-persistent-no-parent': __props.persistent && __props.noParent, 'tooltip-box': (!__props.persistent) || (__props.persistent && !__props.noParent)}),
            style: normalizeStyle(initialPosition.value)
          }, [
            createElementVNode("div", {
              class: normalizeClass(["tooltip-container", {'tooltip-rounded': __props.rounded && !__props.rich, 'tooltip-rich': __props.rich, 'default-tooltip-padding': !__props.rich, 'tooltip-rich-noImg': !__props.visualAsset}])
            }, [
              (!__props.rich)
                ? (openBlock(), createElementBlock("p", _hoisted_1, toDisplayString(__props.content), 1 /* TEXT */))
                : (openBlock(), createElementBlock("div", _hoisted_2, [
                    (__props.visualAsset)
                      ? (openBlock(), createElementBlock("img", {
                          key: 0,
                          class: "rich-tooltip-img",
                          src: __props.visualAsset,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_3))
                      : createCommentVNode("v-if", true),
                    createElementVNode("div", _hoisted_4, [
                      createElementVNode("div", _hoisted_5, [
                        (__props.title)
                          ? (openBlock(), createElementBlock("div", _hoisted_6, toDisplayString(__props.title), 1 /* TEXT */))
                          : createCommentVNode("v-if", true),
                        createElementVNode("i", {
                          class: "fa fa-times close-tooltip",
                          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
                        })
                      ]),
                      createElementVNode("div", _hoisted_7, [
                        (__props.content)
                          ? (openBlock(), createElementBlock("p", _hoisted_8, toDisplayString(__props.content), 1 /* TEXT */))
                          : renderSlot(_ctx.$slots, "content", { key: 1 })
                      ])
                    ]),
                    (__props.hasActions)
                      ? (openBlock(), createElementBlock("div", _hoisted_9, [
                          createElementVNode("div", _hoisted_10, [
                            renderSlot(_ctx.$slots, "firstAction")
                          ]),
                          createElementVNode("div", _hoisted_11, [
                            renderSlot(_ctx.$slots, "secondaryAction")
                          ])
                        ]))
                      : createCommentVNode("v-if", true)
                  ]))
            ], 2 /* CLASS */)
          ], 6 /* CLASS, STYLE */))
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }))
}
}

});

script.__scopeId = "data-v-73684ded";
script.__file = "src/components/Ari-Tooltip/ari-tooltip.vue";

var components = { AriDropdown: script$5, AriButton: script$o, AriForm: script$n, AriInput: script$l, AriTable: script$k, AriTableServer: script$j, AriPagePicker: script$i, AriModal: script$h, AriToast: script$3, AriTooltip: script, AriAbsoluteError: script$m,
                 AriContentTitle: script$g, AriAvatar: script$f, AriInputNumber: script$b, AriToggle: script$a, AriSearchBar: script$7, AriCheckbox: __default__$3, AriTabs: script$4, AriChoice: script$1, AriToastContainer: script$2, AriRadio: script$9 };

const HANDLERS_PROPERTY = '__v-click-outside';
const HAS_WINDOWS = typeof window !== 'undefined';
const HAS_NAVIGATOR = typeof navigator !== 'undefined';
const IS_TOUCH =
  HAS_WINDOWS &&
  ('ontouchstart' in window ||
    (HAS_NAVIGATOR && navigator.msMaxTouchPoints > 0));
const EVENTS = IS_TOUCH ? ['touchstart'] : ['click'];

function processDirectiveArguments(bindingValue) {
  const isFunction = typeof bindingValue === 'function';
  if (!isFunction && typeof bindingValue !== 'object') {
    throw new Error(
      'v-click-outside: Binding value must be a function or an object',
    )
  }

  return {
    handler: isFunction ? bindingValue : bindingValue.handler,
    middleware: bindingValue.middleware || ((item) => item),
    events: bindingValue.events || EVENTS,
    isActive: !(bindingValue.isActive === false),
    detectIframe: !(bindingValue.detectIframe === false),
    capture: !!bindingValue.capture,
  }
}

function execHandler({ event, handler, middleware }) {
  if (middleware(event)) {
    handler(event);
  }
}

function onFauxIframeClick({ el, event, handler, middleware }) {
  // Note: on firefox clicking on iframe triggers blur, but only on
  //       next event loop it becomes document.activeElement
  // https://stackoverflow.com/q/2381336#comment61192398_23231136
  setTimeout(() => {
    const { activeElement } = document;
    if (
      activeElement &&
      activeElement.tagName === 'IFRAME' &&
      !el.contains(activeElement)
    ) {
      execHandler({ event, handler, middleware });
    }
  }, 0);
}

function onEvent({ el, event, handler, middleware }) {
  // Note: composedPath is not supported on IE and Edge, more information here:
  //       https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
  //       In the meanwhile, we are using el.contains for those browsers, not
  //       the ideal solution, but using IE or EDGE is not ideal either.
  const path = (event.composedPath && event.composedPath()) || event.path;
  const isClickOutside = path
    ? path.indexOf(el) < 0
    : !el.contains(event.target);

  if (!isClickOutside) {
    return
  }

  execHandler({ event, handler, middleware });
}

function bind(el, { value }) {
  const {
    events,
    handler,
    middleware,
    isActive,
    detectIframe,
    capture,
  } = processDirectiveArguments(value);
  if (!isActive) {
    return
  }

  el[HANDLERS_PROPERTY] = events.map((eventName) => ({
    event: eventName,
    srcTarget: document.documentElement,
    handler: (event) => onEvent({ el, event, handler, middleware }),
    capture,
  }));

  if (detectIframe) {
    const detectIframeEvent = {
      event: 'blur',
      srcTarget: window,
      handler: (event) => onFauxIframeClick({ el, event, handler, middleware }),
      capture,
    };

    el[HANDLERS_PROPERTY] = [...el[HANDLERS_PROPERTY], detectIframeEvent];
  }

  el[HANDLERS_PROPERTY].forEach(({ event, srcTarget, handler }) =>
    setTimeout(() => {
      // Note: More info about this implementation can be found here:
      //       https://github.com/ndelvalle/v-click-outside/issues/137
      if (!el[HANDLERS_PROPERTY]) {
        return
      }
      srcTarget.addEventListener(event, handler, capture);
    }, 0),
  );
}

function unbind(el) {
  const handlers = el[HANDLERS_PROPERTY] || [];
  handlers.forEach(({ event, srcTarget, handler, capture }) =>
    srcTarget.removeEventListener(event, handler, capture),
  );
  delete el[HANDLERS_PROPERTY];
}

function update(el, { value, oldValue }) {
  if (JSON.stringify(value) === JSON.stringify(oldValue)) {
    return
  }
  unbind(el);
  bind(el, { value });
}

const directive = {
  beforeMount: bind,
  updated: update,
  unmounted: unbind,
};

var clickOutside = HAS_WINDOWS ? directive : {};

var directives = { 'click-outside': clickOutside };

const defaultCustomClasses = {
  buttonsStyling: false,
  customClass: {
    actions: 'ari-footer-confirm',
    input: 'ariInput-height ari-input',
    confirmButton: 'ari-button-base ari-button ari-button-filled ',
    cancelButton: 'ari-button-base ari-button ari-text text-left',
    denyButton: 'ari-button-base ari-button ari-button-filled error-red use-accent-color',
  },
};
/**
 * 
 * @param {String} title Title of the modal 
 * @param {String} body Body of the modal
 * @param {Object} sweetAlertObject Check the SweetAlert2 documentation !
 * @returns promise
 */
const confirm = function (title, body, sweetAlertObject) {
  if (!title || !body) throw new Error('Title and body parameters are mandatory !');
  const myConfirmObject = tools.mergeDeep({
    titleText: title,
    text: body,
    showCancelButton: true,
    denyButtonText: translationService.translate('sa.denyButtonText'),
    cancelButtonText: translationService.translate('sa.cancelButtonText'),
    confirmButtonText: translationService.translate('sa.confirmButtonText'),
    reverseButtons: true,
    customClass: {
      title: 'ari-confirm-title',
      htmlContainer: 'ari-confirm-body',
    }
  }, defaultCustomClasses);
  const finalObject = tools.mergeDeep(myConfirmObject, sweetAlertObject);
  return Swal.fire(handlePushRight(finalObject));
};
/**
 * 
 * @param {String} title 
 * @param {String} body 
 * @param {Object} sweetAlertObject 
 * @returns 
 */
const alert = function (title, body, sweetAlertObject) {
  if (!title || !body) throw new Error('Title and body parameters are mandatory !');
  const myDefaultAlertObject = tools.mergeDeep({
    titleText: title,
    text: body,
    denyButtonText: translationService.translate('sa.denyButtonText'),
    cancelButtonText: translationService.translate('sa.cancelButtonText'),
    confirmButtonText: translationService.translate('sa.alertButtonText'),
    reverseButtons: true,
    customClass: {
      title: 'ari-alert-title',
      htmlContainer: 'ari-alert-body',
    }
  }, defaultCustomClasses);
  const finalObject = tools.mergeDeep(myDefaultAlertObject, sweetAlertObject);
  return Swal.fire(handlePushRight(finalObject));
};

const acceptedInput = ['text', 'email', 'password', 'number', 'tel', 'range', 'textarea', 'select', 'radio', 'checkbox', 'file', 'url'];
/**
 * 
 * @param {String} title 
 * @param {String} input 
 * @param {Object} sweetAlertObject 
 * @returns 
 */
const prompt = function (title, input, placeholder, inputLabel, sweetAlertObject) {
  if (!acceptedInput.includes(input)) throw new Error(`'input' parameter isn't valid. Current 'input': ${input}. Valid 'input': ${acceptedInput}`)
  if (!title || !input || !placeholder) throw new Error('Title, input and placeholder parameters are mandatory !')
  const myDefaultPromptObject = tools.mergeDeep({
    titleText: title,
    showCancelButton: true,
    denyButtonText: translationService.translate('sa.denyButtonText'),
    cancelButtonText: translationService.translate('sa.cancelButtonText'),
    confirmButtonText: translationService.translate('sa.promptButtonText'),
    input: input,
    inputLabel: inputLabel,
    inputPlaceholder: placeholder,
    reverseButtons: true,
    customClass: {
      title: 'ari-prompt-title',
      htmlContainer: 'ari-prompt-body'
    }
  }, defaultCustomClasses);
  const finalObject = tools.mergeDeep(myDefaultPromptObject, sweetAlertObject);
  finalObject.customClass.inputLabel = handleInputLabelPlacement(finalObject);
  return Swal.fire(handlePushRight(finalObject))
};

  const handlePushRight = function (fullConfig) {
    if (fullConfig.showDenyButton) fullConfig.customClass.denyButton += ' push-to-right';
    else fullConfig.customClass.confirmButton += ' push-to-right';
    return fullConfig;
  };
  const handleInputLabelPlacement = function (fullConfig) {
    if (fullConfig.inputLabel) {
      if (fullConfig.text) return 'swal2-input-label_col-4';
      else return 'swal2-input-label_col-3';
    } else return '';
  };
  const getSwalInstance$1 = function () {
    return Swal;
  };
var sweetAlertIntegration = { ariFire: Swal.fire, ariConfirm: confirm, ariAlert: alert, ariPrompt: prompt, getSwalInstance: getSwalInstance$1 };

var utils = { ...sweetAlertIntegration };

// Here is the code called when you use App.use( ... )
const plugin = {
  install (app, options) {
    app.config.globalProperties[`$ariane`] = translationService;

    for (const propComponent in components) {
      // eslint-disable-next-line no-prototype-builtins
      if (components.hasOwnProperty(propComponent)) {
        const component = components[propComponent];
        const componentName = (component.name || component.__name);
        const sanitizedComponentName = [];
        let forceUpperNextChar = true;
        componentName.split('').forEach(char => {
          if (forceUpperNextChar) {
            forceUpperNextChar = false;
            sanitizedComponentName.push(char.toUpperCase());
          } else if (char === '-' || char === '_') {
            forceUpperNextChar = true;
          } else {
            sanitizedComponentName.push(char);
          }
        });
        app.component(sanitizedComponentName.join(''), component);
      }
    }
    for (const propDirective in directives) {
      // eslint-disable-next-line no-prototype-builtins
      if (directives.hasOwnProperty(propDirective)) {
        const directive = directives[propDirective];
        app.directive(propDirective, directive);
      }
    }
    for (const tool in utils) {
      // eslint-disable-next-line no-prototype-builtins
      if (utils.hasOwnProperty(tool)) {
        const vueProto = utils[tool];
        app.config.globalProperties[`$${tool}`] = vueProto;
      }
    }
    app.config.globalProperties[`$ariane`] = {
      lang: translationService
    };
    if (options?.currentLocale) translationService.setCurrentLang(options.currentLocale);
    if (options?.locales) translationService.mergeLanguages(options.locales);
  }
};
const ariConfirm = utils.ariConfirm;
const ariFire = utils.ariFire;
const ariAlert = utils.ariAlert;
const ariPrompt = utils.ariPrompt;
const getSwalInstance = utils.getSwalInstance;
const AriFormMixin = script$d;

export { AriFormMixin, ariAlert, ariConfirm, ariFire, ariPrompt, plugin as default, getSwalInstance, useAriToast };
